(function () {
  'use strict';

  window.KS = window.KS || {};
  var KS = window.KS;

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function qsa(sel, ctx) {
    return Array.from((ctx || document).querySelectorAll(sel));
  }

  function formatMoney(cents) {
    var num = Number(cents) / 100;
    var label = KS.currencyLabel || 'Rs.';
    return label + ' ' + num.toLocaleString('en-PK', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  var CALL_FOR_PRICE_TAG = 'Call for Price';

  function callForPriceLabel() {
    return (KS.strings && KS.strings.callForPrice) || 'Call for Price';
  }

  /** Tag-gated only — never infer from price == 0. */
  function productIsCallForPrice(product) {
    if (!product) return false;
    var tags = product.tags;
    if (!tags) return false;
    if (Array.isArray(tags)) return tags.indexOf(CALL_FOR_PRICE_TAG) > -1;
    if (typeof tags === 'string') {
      return tags
        .split(',')
        .map(function (t) {
          return t.trim();
        })
        .indexOf(CALL_FOR_PRICE_TAG) > -1;
    }
    return false;
  }

  function cartDomHasCallForPrice() {
    var found = false;
    qsa('[data-cart-item][data-call-for-price="true"]').forEach(function (el) {
      if (el.getAttribute('data-pending-remove') === 'true') return;
      if (el.style.display === 'none') return;
      found = true;
    });
    if (found) return true;
    if (qs('[data-cart-totals][data-call-for-price="true"]')) return true;
    if (qs('[data-cart-footer][data-call-for-price="true"]')) return true;
    return false;
  }

  function displayMoneyOrCallForPrice(cents, isCallForPrice) {
    return isCallForPrice ? callForPriceLabel() : formatMoney(cents);
  }

  function getStoredList(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || '[]');
    } catch (e) {
      return [];
    }
  }

  function setStoredList(key, list) {
    localStorage.setItem(key, JSON.stringify(list));
  }

  /** Shopify product handles only — rejects path traversal / attribute breakout. */
  function isProductHandle(handle) {
    return typeof handle === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/i.test(handle) && handle.length <= 255;
  }

  /** Allow only same-origin relative paths or http(s) URLs (blocks javascript:/data:). */
  function isSafeHttpUrl(url) {
    if (!url || typeof url !== 'string') return false;
    var trimmed = url.trim();
    if (!trimmed || /^\s*javascript:/i.test(trimmed) || /^\s*data:/i.test(trimmed)) return false;
    if (trimmed.charAt(0) === '/' && trimmed.charAt(1) !== '/') return true;
    try {
      var parsed = new URL(trimmed, window.location.origin);
      return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch (e) {
      return false;
    }
  }

  function normalizeAddQuantity(raw) {
    var n = parseInt(String(raw == null ? '1' : raw).trim(), 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > 9999) n = 9999;
    return n;
  }

  /* ---------------------------------------------------------------- *
   * Saved products (wishlist + compare)
   *
   * Shopify has no native anonymous wishlist/compare API, so the list of
   * product HANDLES is kept in localStorage for this browser only. Product
   * details are never stored: they are re-read from Shopify via
   * /products/<handle>.js so the catalog stays the single source of truth.
   * ---------------------------------------------------------------- */
  var SAVED_LISTS = {
    wishlist: { key: 'ks_wishlist', limit: 50 },
    compare: { key: 'ks_compare', limit: Number(KS.compareLimit) || 4 }
  };

  function readSaved(name) {
    var cfg = SAVED_LISTS[name];
    if (!cfg) return [];
    var seen = {};
    return getStoredList(cfg.key)
      .filter(function (handle) {
        if (!isProductHandle(handle) || seen[handle]) return false;
        seen[handle] = true;
        return true;
      })
      .slice(0, cfg.limit);
  }

  function writeSaved(name, list) {
    setStoredList(SAVED_LISTS[name].key, list.slice(0, SAVED_LISTS[name].limit));
  }

  function toggleSaved(name, handle) {
    if (!isProductHandle(handle)) {
      return { state: 'invalid', count: readSaved(name).length };
    }
    var limit = SAVED_LISTS[name].limit;
    var list = readSaved(name);
    var at = list.indexOf(handle);

    if (at > -1) {
      list.splice(at, 1);
      writeSaved(name, list);
      return { state: 'removed', count: list.length };
    }
    if (list.length >= limit) {
      // Never silently drop an existing entry.
      return { state: 'limit', count: list.length, limit: limit };
    }
    list.push(handle);
    writeSaved(name, list);
    return { state: 'added', count: list.length };
  }

  function clearSaved(name) {
    writeSaved(name, []);
    return { state: 'cleared', count: 0 };
  }

  function savedHandleOf(btn, name) {
    return (
      btn.getAttribute('data-' + name + '-toggle') ||
      btn.getAttribute('data-' + name + '-add') ||
      btn.getAttribute('data-product-handle') ||
      ''
    );
  }

  function syncSavedToggles(selector, list, name) {
    qsa(selector).forEach(function (btn) {
      var handle = savedHandleOf(btn, name);
      if (!handle) return;
      var active = list.indexOf(handle) > -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');

      var label = btn.getAttribute(active ? 'data-label-active' : 'data-label-idle');
      if (label) {
        btn.setAttribute('aria-label', label);
        var labelEl = qs('[data-toggle-label]', btn);
        if (labelEl) labelEl.textContent = label;
      }
    });
  }

  function syncSavedUI() {
    var wishlist = readSaved('wishlist');
    var compare = readSaved('compare');

    qsa('[data-wishlist-count]').forEach(function (el) {
      el.textContent = wishlist.length;
      el.hidden = wishlist.length === 0;
    });

    qsa('[data-compare-count]').forEach(function (el) {
      el.textContent = compare.length;
      el.hidden = compare.length === 0;
    });

    /* Only walk toggle buttons when any exist (avoids work on pages without cards). */
    if (qs('[data-wishlist-toggle], [data-wishlist-add], [data-compare-toggle]')) {
      syncSavedToggles('[data-wishlist-toggle], [data-wishlist-add]', wishlist, 'wishlist');
      syncSavedToggles('[data-compare-toggle]', compare, 'compare');
    }
  }

  var overlay = qs('[data-overlay]');

  function setOverlay(show) {
    if (!overlay) return;
    if (show) {
      overlay.hidden = false;
      requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });
    } else {
      overlay.classList.remove('is-visible');
      setTimeout(function () {
        if (!document.body.classList.contains('drawer-open')) overlay.hidden = true;
      }, 300);
    }
  }

  function trapFocus(container) {
    var focusable = qsa(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
      container
    ).filter(function (el) {
      return !el.hasAttribute('disabled') && el.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (container._ksTrapHandler) {
      container.removeEventListener('keydown', container._ksTrapHandler);
    }
    container._ksTrapHandler = function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    container.addEventListener('keydown', container._ksTrapHandler);
  }

  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    document.body.classList.add('drawer-open');
    document.body.style.overflow = 'hidden';
    setOverlay(true);
    trapFocus(el);
  }

  function closeDrawers() {
    qsa('.cart-drawer.is-open, .mobile-nav.is-open, .search-drawer.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
    document.body.classList.remove('drawer-open');
    document.body.style.overflow = '';
    setOverlay(false);
  }

  function hydrateDataSrcImages(root) {
    qsa('img[data-src]', root || document).forEach(function (img) {
      if (img.classList.contains('hero__banner')) return;
      var url = img.getAttribute('data-src');
      var srcset = img.getAttribute('data-srcset');
      if (!url && !srcset) return;
      if (srcset) img.setAttribute('srcset', srcset);
      if (url) img.setAttribute('src', url);
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }

  function initDeferredSectionImages() {
    var imgs = [];
    qsa('img[data-src]').forEach(function (img) {
      if (!img.classList.contains('hero__banner')) imgs.push(img);
    });
    if (!imgs.length) return;

    function hydrate(img) {
      if (!img || img.classList.contains('hero__banner')) return;
      var url = img.getAttribute('data-src');
      var srcset = img.getAttribute('data-srcset');
      if (!url && !srcset) return;
      if (srcset) img.setAttribute('srcset', srcset);
      if (url) img.setAttribute('src', url);
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }

    function startObserving() {
      if (!('IntersectionObserver' in window)) {
        imgs.forEach(hydrate);
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            hydrate(entry.target);
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '120px 0px', threshold: 0.01 }
      );
      imgs.forEach(function (img) {
        io.observe(img);
      });
    }

    /* Wait for LCP hero so below-fold assets do not compete on Slow 4G. */
    var firstHero = qs('[data-hero-slide].is-active img.hero__banner') || qs('img.hero__banner');
    var started = false;
    function startOnce() {
      if (started) return;
      started = true;
      startObserving();
    }
    if (firstHero && !firstHero.complete) {
      firstHero.addEventListener('load', startOnce, { once: true });
      firstHero.addEventListener('error', startOnce, { once: true });
      setTimeout(startOnce, 10000);
    } else {
      startOnce();
    }
  }

  if (overlay) overlay.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });

  qsa('[data-mobile-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = qs('[data-mobile-nav]');
      if (!nav) return;
      if (nav.classList.contains('is-open')) closeDrawers();
      else {
        closeDrawers();
        hydrateDataSrcImages(nav);
        openDrawer(nav);
      }
    });
  });

  qsa('[data-mobile-nav-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawers);
  });

  qsa('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = qs('[data-search-drawer]');
      if (!drawer) return;
      if (drawer.classList.contains('is-open')) closeDrawers();
      else {
        closeDrawers();
        openDrawer(drawer);
        var input = qs('input[type="search"]', drawer);
        if (input) setTimeout(function () { input.focus(); }, 50);
      }
    });
  });

  qsa('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawers);
  });

  function openCartDrawer() {
    if (!KS.cartDrawer) {
      window.location.href = KS.routes.cart_url;
      return;
    }
    var drawer = qs('[data-cart-drawer]');
    if (!drawer) {
      window.location.href = KS.routes.cart_url || '/cart';
      return;
    }
    closeDrawers();
    openDrawer(drawer);
  }

  function updateShippingBar(totalCents) {
    if (!KS.showFreeShippingBar || !KS.freeShippingThreshold) return;
    var bar = qs('[data-shipping-bar]');
    if (!bar) return;
    var text = qs('[data-shipping-text]', bar);
    var fill = qs('[data-shipping-fill]', bar);
    var threshold = Number(KS.freeShippingThreshold);
    var remaining = threshold - Number(totalCents);
    if (remaining <= 0) {
      /* textContent — locale strings must not inject HTML */
      if (text) text.textContent = KS.strings.shippingUnlocked || '';
      if (fill) fill.style.width = '100%';
    } else {
      if (text) {
        text.textContent = String(KS.strings.shippingRemaining || '').replace(
          '{{ amount }}',
          formatMoney(remaining)
        );
      }
      if (fill) fill.style.width = Math.min(100, (totalCents / threshold) * 100) + '%';
    }
  }

  function syncCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = Number(count) === 0;
    });
  }

  function syncCartSubtotal(totalCents) {
    var useCfp = cartDomHasCallForPrice();
    var label = useCfp ? callForPriceLabel() : formatMoney(totalCents);
    qsa('[data-cart-subtotal], [data-cart-total]').forEach(function (el) {
      el.textContent = label;
    });
  }

  function syncCartItemsSubtotal(cents) {
    if (cents == null && !cartDomHasCallForPrice()) return;
    var useCfp = cartDomHasCallForPrice();
    var label = useCfp ? callForPriceLabel() : formatMoney(cents);
    qsa('[data-cart-items-subtotal]').forEach(function (el) {
      el.textContent = label;
    });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function syncCartDiscountRows(cart) {
    var hosts = qsa('[data-cart-discount-rows]');
    if (!hosts.length || !cart) return;
    var html = '';
    var apps = cart.cart_level_discount_applications || [];
    var discountLabel = (KS.strings && KS.strings.discountLabel) || 'Discount';
    if (apps.length) {
      apps.forEach(function (discount) {
        var title = discount.title || discount.code || '';
        var amount = discount.total_allocated_amount != null
          ? discount.total_allocated_amount
          : discount.amount;
        html +=
          '<div class="cart-totals__row cart-totals__row--discount">' +
          '<span>' + escapeHtml(discountLabel) +
          (title ? ' (' + escapeHtml(title) + ')' : '') +
          '</span>' +
          '<span>−' + formatMoney(amount || 0) + '</span>' +
          '</div>';
      });
    } else if (cart.total_discount > 0) {
      html =
        '<div class="cart-totals__row cart-totals__row--discount">' +
        '<span>' + escapeHtml(discountLabel) + '</span>' +
        '<span>−' + formatMoney(cart.total_discount) + '</span>' +
        '</div>';
    }
    hosts.forEach(function (host) {
      host.innerHTML = html;
    });

    var hasDiscount = (cart.total_discount > 0) || apps.length > 0 ||
      (cart.discount_codes || []).some(function (c) { return c && c.applicable; });
    qsa('[data-discount-clear]').forEach(function (btn) {
      btn.hidden = !hasDiscount;
    });
  }

  function getCartDrawerSectionId() {
    var drawer = qs('[data-cart-drawer]');
    return (drawer && drawer.getAttribute('data-section-id')) || 'cart-drawer';
  }

  function refreshCartDrawer() {
    if (!KS.cartDrawer) return Promise.resolve();
    var sectionId = getCartDrawerSectionId();
    return fetch(cartRoute('root_url', '/') + '?section_id=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        var current = qs('[data-cart-drawer]');
        if (newDrawer && current) {
          var wasOpen = current.classList.contains('is-open');
          current.replaceWith(newDrawer);
          var drawer = qs('[data-cart-drawer]');
          if (wasOpen && drawer) {
            drawer.classList.add('is-open');
            trapFocus(drawer);
          }
        }
        var countMatch = doc.querySelector('[data-cart-count]');
        if (countMatch) {
          syncCartCount(countMatch.textContent.trim());
        }
        updateShippingBar(KS.cartTotal || 0);
      })
      .catch(function () {});
  }

  function refreshMainCart() {
    var root = qs('[data-main-cart]');
    if (!root) return Promise.resolve();
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return Promise.resolve();
    return fetch(cartRoute('cart_url', '/cart') + '?section_id=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var neu = doc.querySelector('[data-main-cart]');
        if (neu && root.parentNode) {
          root.replaceWith(neu);
        }
        updateShippingBar(KS.cartTotal || 0);
      })
      .catch(function () {});
  }

  function cartRoute(name, fallback) {
    return (KS.routes && KS.routes[name]) || fallback;
  }

  function cartChangeEndpoint() {
    return cartRoute('cart_change_url', '/cart/change') + '.js';
  }

  function cartChangeUrl(line, quantity, key) {
    var base = cartRoute('cart_change_url', '/cart/change');
    if (key) {
      return (
        base +
        '?id=' + encodeURIComponent(key) +
        '&quantity=' + encodeURIComponent(quantity)
      );
    }
    return (
      base +
      '?line=' + encodeURIComponent(line) +
      '&quantity=' + encodeURIComponent(quantity)
    );
  }

  function applyCartJson(cart) {
    if (!cart) return;
    /* Single source of truth for displayed cart amount: Shopify cart.total_price.
       Call for Price presentation overrides visible Rs. 0 when tagged lines exist. */
    var total = cart.total_price != null ? cart.total_price : 0;
    var itemsSub = cart.items_subtotal_price != null ? cart.items_subtotal_price : total;
    KS.cartTotal = total;
    syncCartCount(cart.item_count || 0);
    syncCartItemsSubtotal(itemsSub);
    if (!cartDomHasCallForPrice()) {
      syncCartDiscountRows(cart);
    }
    syncCartSubtotal(total);
    updateShippingBar(KS.cartTotal);
  }

  function cartUpdateEndpoint() {
    return cartRoute('cart_update_url', '/cart/update') + '.js';
  }

  function setDiscountStatus(root, message, type) {
    if (!root) return;
    var status = qs('[data-discount-status]', root);
    if (!status) return;
    if (!message) {
      status.textContent = '';
      status.hidden = true;
      status.classList.remove('is-success', 'is-error');
      return;
    }
    status.textContent = message;
    status.hidden = false;
    status.classList.toggle('is-success', type === 'success');
    status.classList.toggle('is-error', type === 'error');
  }

  function discountCodeIsApplicable(cart, code) {
    if (!cart || !code) return false;
    var needle = String(code).trim().toUpperCase();
    var codes = cart.discount_codes || [];
    var i;
    for (i = 0; i < codes.length; i++) {
      if (String(codes[i].code || '').toUpperCase() === needle) {
        return codes[i].applicable !== false;
      }
    }
    var apps = cart.cart_level_discount_applications || [];
    for (i = 0; i < apps.length; i++) {
      var title = String(apps[i].title || apps[i].code || '').toUpperCase();
      if (title === needle) return true;
    }
    return false;
  }

  function updateCartDiscount(code) {
    var body = new FormData();
    body.append('discount', code == null ? '' : String(code));
    return fetch(cartUpdateEndpoint(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: body
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = null;
        try {
          data = text ? JSON.parse(text) : null;
        } catch (err) {
          data = null;
        }
        if (!res.ok) {
          var fail = new Error(
            (data && (data.message || data.description)) || 'discount_update_failed'
          );
          fail.payload = data;
          throw fail;
        }
        return data;
      });
    });
  }

  function applyDiscountFromRoot(root, code) {
    var trimmed = String(code || '').trim();
    if (!trimmed) {
      setDiscountStatus(
        root,
        (KS.strings && KS.strings.discountEmpty) || 'Enter a discount code.',
        'error'
      );
      return Promise.resolve(null);
    }
    var applyBtn = qs('[data-discount-apply]', root);
    if (applyBtn) applyBtn.disabled = true;
    setDiscountStatus(root, '', null);
    return updateCartDiscount(trimmed)
      .then(function (cart) {
        if (!discountCodeIsApplicable(cart, trimmed) && !(cart.total_discount > 0)) {
          setDiscountStatus(
            root,
            (KS.strings && KS.strings.discountInvalid) ||
              'That discount code isn’t valid for this cart.',
            'error'
          );
          return fetchCartJson().then(function (fresh) {
            applyCartJson(fresh);
            return refreshCartSurfaces().then(function () { return fresh; });
          });
        }
        applyCartJson(cart);
        setDiscountStatus(
          root,
          (KS.strings && KS.strings.discountApplied) || 'Discount applied.',
          'success'
        );
        var input = qs('[data-discount-input]', root);
        if (input) input.value = '';
        return refreshCartSurfaces().then(function () { return cart; });
      })
      .catch(function () {
        /* Local preview has no Shopify cart backend — never fake a discount. */
        setDiscountStatus(
          root,
          (KS.strings && KS.strings.discountError) ||
            'We couldn’t apply that code. Please try again.',
          'error'
        );
        return null;
      })
      .finally(function () {
        if (applyBtn) applyBtn.disabled = false;
      });
  }

  function clearDiscountFromRoot(root) {
    var clearBtn = qs('[data-discount-clear]', root);
    if (clearBtn) clearBtn.disabled = true;
    setDiscountStatus(root, '', null);
    return updateCartDiscount('')
      .then(function (cart) {
        applyCartJson(cart);
        setDiscountStatus(
          root,
          (KS.strings && KS.strings.discountRemoved) || 'Discount removed.',
          'success'
        );
        return refreshCartSurfaces().then(function () { return cart; });
      })
      .catch(function () {
        setDiscountStatus(
          root,
          (KS.strings && KS.strings.discountError) ||
            'We couldn’t apply that code. Please try again.',
          'error'
        );
        return null;
      })
      .finally(function () {
        if (clearBtn) clearBtn.disabled = false;
      });
  }

  /**
   * Normalize a cart quantity for Shopify /cart/change.js.
   * Returns an integer >= 0, or null when the value is invalid.
   * 0 means remove the line (Shopify-native).
   */
  function normalizeCartQuantity(raw) {
    if (raw == null || raw === '') return null;
    var n = parseInt(String(raw).trim(), 10);
    if (isNaN(n) || n < 0) return null;
    return n;
  }

  function changeCartLine(line, quantity, key) {
    var qty = normalizeCartQuantity(quantity);
    if (qty == null) {
      return Promise.reject(new Error('invalid_quantity'));
    }
    /* Prefer application/x-www-form-urlencoded — more reliable than multipart FormData
       with Shopify line keys that contain ":". */
    var body = new URLSearchParams();
    if (key) {
      body.set('id', String(key));
    } else if (line != null && line !== '') {
      body.set('line', String(line));
    } else {
      return Promise.reject(new Error('missing_line'));
    }
    body.set('quantity', String(qty));
    return fetch(cartChangeEndpoint(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: body
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return null;
        })
        .then(function (data) {
          if (!res.ok) {
            var err = new Error(
              (data && (data.description || data.message)) || 'Cart change failed'
            );
            err.status = res.status;
            err.payload = data;
            throw err;
          }
          return data;
        });
    });
  }

  function restoreCartFromServer() {
    return fetchCartJson()
      .then(function (cart) {
        applyCartJson(cart);
        var needsFull = patchCartFromJson(cart);
        if (needsFull) return refreshCartSurfaces().then(function () { return cart; });
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function cartErrorMessage(err) {
    var raw = (err && (err.message || (err.payload && (err.payload.description || err.payload.message)))) || '';
    if (/availability|inventory|stock|only \d+ items/i.test(raw)) {
      return raw;
    }
    if (err && err.status === 422) {
      return 'That quantity isn’t available. Your cart was updated to the maximum in stock.';
    }
    return 'We couldn’t update your cart. Please try again.';
  }

  function refreshCartSurfaces() {
    var tasks = [];
    if (qs('[data-cart-drawer]')) {
      tasks.push(refreshCartDrawer());
    }
    if (qs('[data-main-cart]')) {
      tasks.push(refreshMainCart());
    }
    return Promise.all(tasks);
  }

  function cartItemKeySelector(key) {
    var safe = String(key).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    return '[data-cart-item][data-key="' + safe + '"]';
  }

  /** All matching line nodes (drawer + cart page can both be in the DOM). */
  function findCartItemEls(key, line) {
    var found = [];
    var seen = [];
    function push(el) {
      if (!el || seen.indexOf(el) > -1) return;
      seen.push(el);
      found.push(el);
    }
    if (key) {
      qsa(cartItemKeySelector(key)).forEach(push);
    }
    if (line != null && line !== '' && !found.length) {
      qsa('[data-cart-item][data-line="' + String(line) + '"]').forEach(push);
    }
    return found;
  }

  function findCartItemEl(key, line) {
    var all = findCartItemEls(key, line);
    return all.length ? all[0] : null;
  }

  function readLiveLineQty(key, line, preferredItem) {
    var item = preferredItem || findCartItemEl(key, line);
    if (!item) return null;
    var input = qs('[data-qty-input]', item);
    if (!input) return null;
    return normalizeCartQuantity(input.value);
  }

  function setLineControlsBusy(item, busy) {
    if (!item) return;
    /* Visual hint only — never disable pointer events on +/- or the input. */
    item.classList.toggle('is-updating', !!busy);
    item.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function setLineControlsBusyAll(key, line, busy) {
    findCartItemEls(key, line).forEach(function (item) {
      setLineControlsBusy(item, busy);
    });
  }

  function updateLineQtyControls(item, qty) {
    if (!item || qty == null) return;
    var input = qs('[data-qty-input]', item);
    if (input) {
      input.value = String(qty);
      input.setAttribute('data-prev-qty', String(qty));
    }
    var key = item.getAttribute('data-key') || '';
    var line = item.getAttribute('data-line') || '';
    var links = qsa('a[data-qty-change]', item);
    var minus = qs('a[data-qty-change][aria-label*="Decrease" i], a[data-qty-change][aria-label*="decrease" i]', item);
    var plus = qs('a[data-qty-change][aria-label*="Increase" i], a[data-qty-change][aria-label*="increase" i]', item);
    if (!minus && !plus && links.length >= 2) {
      minus = links[0];
      plus = links[1];
    } else if (!minus && !plus && links.length === 1) {
      plus = links[0];
    }
    /* Liquid renders a disabled <span> at qty 1 — promote to a real control when qty rises. */
    if (qty > 1 && !minus) {
      var disabledMinus = qs('span.cart-item__qty-btn.is-disabled', item);
      if (disabledMinus) {
        minus = document.createElement('a');
        minus.className = 'cart-item__qty-btn';
        minus.setAttribute('data-qty-change', '');
        minus.setAttribute('href', '#');
        minus.setAttribute(
          'aria-label',
          (KS.strings && KS.strings.decrease) || 'Decrease quantity'
        );
        minus.textContent = disabledMinus.textContent || '−';
        disabledMinus.replaceWith(minus);
      }
    }
    var changeBase = cartRoute('cart_change_url', '/cart/change');
    if (plus) {
      var nextPlus = qty + 1;
      plus.setAttribute('data-quantity', String(nextPlus));
      plus.setAttribute('data-key', key);
      plus.setAttribute('data-line', line);
      plus.setAttribute(
        'href',
        changeBase +
          (key
            ? '?id=' + encodeURIComponent(key) + '&quantity=' + nextPlus
            : '?line=' + encodeURIComponent(line) + '&quantity=' + nextPlus)
      );
    }
    if (qty > 1) {
      if (minus) {
        var nextMinus = qty - 1;
        minus.setAttribute('data-quantity', String(nextMinus));
        minus.setAttribute('data-key', key);
        minus.setAttribute('data-line', line);
        minus.setAttribute(
          'href',
          changeBase +
            (key
              ? '?id=' + encodeURIComponent(key) + '&quantity=' + nextMinus
              : '?line=' + encodeURIComponent(line) + '&quantity=' + nextMinus)
        );
        minus.hidden = false;
        minus.style.display = '';
        minus.removeAttribute('aria-disabled');
        minus.style.pointerEvents = '';
        minus.style.opacity = '';
      }
    } else if (minus && minus.tagName === 'A') {
      /* Demote interactive minus back to a disabled stand-in at qty 1. */
      var span = document.createElement('span');
      span.className = 'cart-item__qty-btn is-disabled';
      span.setAttribute('aria-hidden', 'true');
      span.textContent = minus.textContent || '−';
      minus.replaceWith(span);
    }
    if (key) {
      qsa('a[data-qty-change], a[data-remove-line]', item).forEach(function (a) {
        var q = a.getAttribute('data-quantity');
        if (q == null) return;
        a.setAttribute(
          'href',
          changeBase + '?id=' + encodeURIComponent(key) + '&quantity=' + encodeURIComponent(q)
        );
      });
    }
  }

  function optimisticLinePaint(key, line, qty, preferredItem) {
    var items = findCartItemEls(key, line);
    if (preferredItem && items.indexOf(preferredItem) === -1) items.unshift(preferredItem);
    if (!items.length) return null;

    var primary = preferredItem && items.indexOf(preferredItem) > -1 ? preferredItem : items[0];
    var input = qs('[data-qty-input]', primary);
    var prev = input ? normalizeCartQuantity(input.value) : null;
    if (prev == null) prev = 1;

    items.forEach(function (item) {
      if (qty === 0) {
        /* Instant remove: hide immediately; restore from server if sync fails. */
        item.style.display = 'none';
        item.setAttribute('data-pending-remove', 'true');
        item.setAttribute('aria-hidden', 'true');
        return;
      }
      item.style.display = '';
      item.style.opacity = '';
      item.removeAttribute('data-pending-remove');
      item.removeAttribute('aria-hidden');
      updateLineQtyControls(item, qty);
      var lineTotal = qs('[data-line-total]', item);
      var isCfp = item.getAttribute('data-call-for-price') === 'true';
      if (lineTotal) {
        if (isCfp) {
          lineTotal.textContent = callForPriceLabel();
        } else {
          /* Use Shopify cents from data-unit-price — never re-parse formatted money (avoids extra zeros). */
          var unitCents = parseInt(item.getAttribute('data-unit-price') || '', 10);
          if (!isNaN(unitCents) && unitCents >= 0) {
            lineTotal.textContent = formatMoney(unitCents * qty);
          }
        }
      }
    });

    var delta = qty - prev;
    var countEl = qs('[data-cart-count]');
    var currentCount = countEl ? parseInt(countEl.textContent, 10) : NaN;
    if (!isNaN(currentCount)) {
      syncCartCount(Math.max(0, currentCount + delta));
    }

    /* Optimistic items-subtotal from visible line totals (cents attrs), when safe. */
    if (primary) {
      var rough = 0;
      var keysSeen = {};
      qsa('[data-cart-item]').forEach(function (el) {
        if (el.getAttribute('data-pending-remove') === 'true' || el.style.display === 'none') return;
        var k = el.getAttribute('data-key') || el.getAttribute('data-line') || '';
        if (!k || keysSeen[k]) return;
        keysSeen[k] = true;
        var u = parseInt(el.getAttribute('data-unit-price') || '', 10);
        var qEl = qs('[data-qty-input]', el);
        var q = qEl ? normalizeCartQuantity(qEl.value) : null;
        if (!isNaN(u) && q != null) rough += u * q;
      });
      syncCartItemsSubtotal(rough);
      syncCartSubtotal(rough);
    }

    return { item: primary, items: items, prev: prev };
  }

  /**
   * Patch existing cart line DOM from Shopify cart JSON.
   * Returns true when a full section refresh is still required.
   */
  function patchCartFromJson(cart) {
    if (!cart) return true;
    applyCartJson(cart);
    var items = cart.items || [];
    var bodies = qsa('[data-cart-body]');
    if (!bodies.length) return true;

    if (items.length === 0) {
      return true; /* empty state markup needs Liquid */
    }

    var seen = {};
    var missing = false;
    items.forEach(function (item, index) {
      var els = findCartItemEls(item.key, index + 1);
      if (!els.length) {
        missing = true;
        return;
      }
      seen[item.key] = true;
      els.forEach(function (el) {
        el.style.opacity = '';
        el.style.display = '';
        el.removeAttribute('data-pending-remove');
        el.removeAttribute('aria-hidden');
        el.setAttribute('data-key', item.key);
        el.setAttribute('data-line', String(index + 1));
        if (item.final_price != null) {
          el.setAttribute('data-unit-price', String(item.final_price));
        }
        updateLineQtyControls(el, item.quantity);
        var lineTotal = qs('[data-line-total]', el);
        var isCfp = el.getAttribute('data-call-for-price') === 'true';
        if (lineTotal) {
          if (isCfp) {
            lineTotal.textContent = callForPriceLabel();
          } else if (item.final_line_price != null) {
            lineTotal.textContent = formatMoney(item.final_line_price);
          }
        }
        setLineControlsBusy(el, false);
      });
    });

    qsa('[data-cart-item]').forEach(function (el) {
      var k = el.getAttribute('data-key');
      if (k && !seen[k]) el.remove();
    });

    /* If any cart surface has zero items left in DOM but cart isn't empty, refresh. */
    qsa('[data-cart-body]').forEach(function (body) {
      if (!qs('[data-cart-item]', body) && items.length) missing = true;
    });

    return missing;
  }

  var cartQueue = Promise.resolve();
  var pendingLineOps = {};
  var lineSyncScheduled = {};

  function lineOpId(key, line) {
    return key ? 'k:' + key : 'l:' + String(line);
  }

  function enqueueCartTask(task) {
    cartQueue = cartQueue.then(task, task);
    return cartQueue;
  }

  function cartAddEndpoint() {
    return cartRoute('cart_add_url', '/cart/add') + '.js';
  }

  function fetchCartJson() {
    return fetch(cartRoute('cart_url', '/cart') + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('cart_fetch_failed');
      return r.json();
    });
  }

  function addToCartFromForm(form) {
    var formData = new FormData(form);
    var variantId = formData.get('id');
    if (!variantId) {
      return Promise.reject(new Error('missing_variant_id'));
    }
    var addQty = normalizeAddQuantity(formData.get('quantity'));
    formData.set('quantity', String(addQty));

    /* Optimistic count bump runs inside the cart queue to avoid race
       restores when multiple adds are in flight. */
    return enqueueCartTask(function () {
      var countEl = qs('[data-cart-count]');
      var prevCount = countEl ? parseInt(countEl.textContent, 10) : 0;
      if (isNaN(prevCount)) prevCount = 0;
      syncCartCount(prevCount + addQty);

      return fetch(cartAddEndpoint(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) {
          if (!r.ok) {
            var err = new Error('cart_add_failed');
            err.status = r.status;
            throw err;
          }
          return r.json();
        })
        .then(function () {
          return fetchCartJson().then(function (cart) {
            applyCartJson(cart);
            var needsFull = patchCartFromJson(cart);
            var done = needsFull ? refreshCartSurfaces() : Promise.resolve();
            return done.then(function () {
              if (KS.cartDrawer) openCartDrawer();
              return null;
            });
          });
        })
        .catch(function (err) {
          return fetchCartJson()
            .then(function (cart) {
              applyCartJson(cart);
              patchCartFromJson(cart);
            })
            .catch(function () {
              syncCartCount(prevCount);
            })
            .then(function () {
              throw err;
            });
        });
    });
  }

  function clickEl(e) {
    var t = e.target;
    if (t && t.nodeType === 3) t = t.parentElement;
    return t && t.nodeType === 1 ? t : null;
  }

  function quantityFromControl(el) {
    var qty = el.getAttribute('data-quantity');
    if (qty != null && qty !== '') return qty;
    var href = el.getAttribute('href');
    if (!href) return null;
    try {
      return new URL(href, window.location.origin).searchParams.get('quantity');
    } catch (err) {
      return null;
    }
  }

  function resolveNextQty(qtyLink, key, line, preferredItem) {
    var live = readLiveLineQty(key, line, preferredItem);
    var marked = normalizeCartQuantity(quantityFromControl(qtyLink));
    if (live == null) return marked;
    if (marked == null) return live;
    if (marked > live) return live + 1;
    if (marked < live) return Math.max(1, live - 1);
    return marked;
  }

  /**
   * Queue at most one in-flight Shopify sync per line.
   * Rapid +/- updates pending intent; UI paints immediately; network catches up to latest qty.
   */
  function applyLineChange(line, quantity, fallbackHref, key, preferredItem) {
    var qty = normalizeCartQuantity(quantity);
    if (qty == null) {
      return Promise.reject(new Error('invalid_quantity'));
    }

    var opId = lineOpId(key, line);
    pendingLineOps[opId] = {
      line: line,
      qty: qty,
      key: key,
      fallbackHref: fallbackHref
    };

    var paint = optimisticLinePaint(key, line, qty, preferredItem);
    if (paint && paint.items) {
      paint.items.forEach(function (item) {
        setLineControlsBusy(item, true);
      });
    } else if (paint && paint.item) {
      setLineControlsBusy(paint.item, true);
    }

    if (lineSyncScheduled[opId]) {
      return cartQueue;
    }
    lineSyncScheduled[opId] = true;

    return enqueueCartTask(function syncLine() {
      function run() {
        var op = pendingLineOps[opId];
        if (!op) {
          delete lineSyncScheduled[opId];
          setLineControlsBusyAll(key, line, false);
          return Promise.resolve(null);
        }

        var targetQty = op.qty;
        var targetKey = op.key;
        var targetLine = op.line;
        var targetFallback = op.fallbackHref;

        optimisticLinePaint(targetKey, targetLine, targetQty, preferredItem);
        setLineControlsBusyAll(targetKey, targetLine, true);

        return changeCartLine(targetLine, targetQty, targetKey)
          .then(function (cart) {
            var latest = pendingLineOps[opId];
            if (latest && latest.qty !== targetQty) {
              /* Intent moved while request was in flight — sync latest only. */
              return run();
            }
            delete pendingLineOps[opId];
            delete lineSyncScheduled[opId];
            applyCartJson(cart);
            var needsFull = patchCartFromJson(cart);
            /* Full section HTML replace only when patch cannot represent the cart (e.g. empty). */
            if (needsFull) return refreshCartSurfaces();
            setLineControlsBusyAll(targetKey, targetLine, false);
            return null;
          })
          .catch(function (err) {
            delete pendingLineOps[opId];
            delete lineSyncScheduled[opId];
            /* NEVER navigate to /cart/change HTML — that surfaces HTTP ERROR 422. */
            if (typeof console !== 'undefined' && console.warn) {
              console.warn('[KS cart]', err && err.status, err && err.message, err && err.payload);
            }
            showToast(cartErrorMessage(err));
            return restoreCartFromServer().then(function () {
              setLineControlsBusyAll(targetKey, targetLine, false);
              return null;
            });
          });
      }

      return run();
    });
  }

  document.addEventListener('click', function (e) {
    var el = clickEl(e);
    if (!el) return;

    var qtyLink = el.closest('a[data-qty-change]');
    if (qtyLink) {
      var line = qtyLink.getAttribute('data-line');
      var key = qtyLink.getAttribute('data-key');
      var itemEl = qtyLink.closest('[data-cart-item]');
      var qty = resolveNextQty(qtyLink, key, line, itemEl);
      if ((!line && !key) || qty == null || qty < 1) return;
      e.preventDefault();
      applyLineChange(line, qty, qtyLink.getAttribute('href'), key, itemEl);
      return;
    }

    var removeLink = el.closest('a[data-remove-line]');
    if (removeLink) {
      var rLine = removeLink.getAttribute('data-line');
      var rKey = removeLink.getAttribute('data-key');
      var rItem = removeLink.closest('[data-cart-item]');
      var rQty = normalizeCartQuantity(quantityFromControl(removeLink));
      if (!rLine && !rKey) return;
      e.preventDefault();
      applyLineChange(rLine, rQty != null ? rQty : 0, removeLink.getAttribute('href'), rKey, rItem);
      return;
    }

    var discountApply = el.closest('[data-discount-apply]');
    if (discountApply) {
      e.preventDefault();
      var discountRoot = discountApply.closest('[data-cart-discount]');
      var discountInput = discountRoot && qs('[data-discount-input]', discountRoot);
      applyDiscountFromRoot(discountRoot, discountInput ? discountInput.value : '');
      return;
    }

    var discountClear = el.closest('[data-discount-clear]');
    if (discountClear) {
      e.preventDefault();
      clearDiscountFromRoot(discountClear.closest('[data-cart-discount]'));
      return;
    }

    var openTrig = el.closest('[data-cart-drawer-open], [data-cart-toggle]');
    if (openTrig) {
      if (KS.cartDrawer) {
        e.preventDefault();
        openCartDrawer();
      }
      return;
    }

    var closeTrig = el.closest('[data-cart-drawer-close], [data-cart-close]');
    if (closeTrig) {
      e.preventDefault();
      closeDrawers();
      return;
    }

    // Links that navigate away (View cart / Continue shopping) close the drawer
    // without blocking their href.
    if (el.closest('[data-cart-close-link]')) {
      closeDrawers();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target && e.target.closest ? e.target.closest('[data-discount-input]') : null;
    if (!input) return;
    e.preventDefault();
    var root = input.closest('[data-cart-discount]');
    applyDiscountFromRoot(root, input.value);
  });

  /* Remember last valid qty so invalid direct input can be restored. */
  document.addEventListener('focusin', function (e) {
    var input = e.target && e.target.closest ? e.target.closest('[data-qty-input][data-line]') : null;
    if (!input) return;
    input.setAttribute('data-prev-qty', String(input.value || '1'));
  });

  var qtyInputTimers = {};

  function commitQtyInput(input, immediate) {
    if (!input) return;
    var line = input.getAttribute('data-line');
    var key = input.getAttribute('data-key');
    if (!line && !key) return;
    var opId = lineOpId(key, line);
    if (qtyInputTimers[opId]) {
      clearTimeout(qtyInputTimers[opId]);
      delete qtyInputTimers[opId];
    }

    var qty = normalizeCartQuantity(input.value);
    if (qty == null) {
      input.value = input.getAttribute('data-prev-qty') || '1';
      return;
    }

    /* 0 removes the line via Shopify; otherwise keep a clean integer in the field. */
    if (qty > 0) input.value = String(qty);
    var itemEl = input.closest('[data-cart-item]');
    applyLineChange(line, qty, cartChangeUrl(line, qty, key), key, itemEl);
  }

  /* Debounced typing — avoid a request per keystroke (1 → 10 → 100). */
  document.addEventListener('input', function (e) {
    var input = e.target && e.target.closest ? e.target.closest('[data-qty-input][data-line]') : null;
    if (!input) return;
    var line = input.getAttribute('data-line');
    var key = input.getAttribute('data-key');
    var opId = lineOpId(key, line);
    /* Optimistic line total while typing, without hitting Shopify yet. */
    var typed = normalizeCartQuantity(input.value);
    var itemEl = input.closest('[data-cart-item]');
    if (itemEl && typed != null && typed > 0) {
      var lineTotal = qs('[data-line-total]', itemEl);
      if (lineTotal) {
        if (itemEl.getAttribute('data-call-for-price') === 'true') {
          lineTotal.textContent = callForPriceLabel();
        } else {
          var unitCents = parseInt(itemEl.getAttribute('data-unit-price') || '', 10);
          if (!isNaN(unitCents)) lineTotal.textContent = formatMoney(unitCents * typed);
        }
      }
    }
    if (qtyInputTimers[opId]) clearTimeout(qtyInputTimers[opId]);
    qtyInputTimers[opId] = setTimeout(function () {
      delete qtyInputTimers[opId];
      commitQtyInput(input, true);
    }, 280);
  });

  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest ? e.target.closest('[data-qty-input][data-line]') : null;
    if (!input) return;
    commitQtyInput(input, true);
  });

  function knownCartCount() {
    var counter = qs('[data-cart-count]');
    if (counter) {
      var parsed = parseInt(counter.textContent, 10);
      if (!isNaN(parsed)) return parsed;
    }
    return qsa('[data-cart-item]').length;
  }

  function showCheckoutError(form, message) {
    var target = qs('[data-checkout-error]', form);
    if (!target) return;
    target.textContent = message;
    target.hidden = false;
  }

  // Guards the native Shopify checkout POST. It never replaces or simulates
  // checkout: it only blocks a submit that Shopify could not fulfil.
  document.addEventListener('submit', function (e) {
    var checkoutForm = e.target.closest('[data-checkout-form]');
    if (!checkoutForm) return;

    var errorEl = qs('[data-checkout-error]', checkoutForm);
    if (errorEl) errorEl.hidden = true;

    if (knownCartCount() < 1) {
      e.preventDefault();
      showCheckoutError(
        checkoutForm,
        (KS.strings && KS.strings.checkoutEmpty) || 'Your cart is empty.'
      );
      return;
    }

    var checkoutBtn = qs('[name="checkout"]', checkoutForm);
    if (checkoutBtn) {
      checkoutBtn.setAttribute('aria-busy', 'true');
      // Deferred so the browser still serialises name="checkout" with the POST.
      setTimeout(function () {
        checkoutBtn.disabled = true;
      }, 0);
      // Re-enable if the browser restores this page from cache instead of
      // navigating to Shopify checkout.
      window.addEventListener(
        'pageshow',
        function () {
          checkoutBtn.disabled = false;
          checkoutBtn.removeAttribute('aria-busy');
        },
        { once: true }
      );
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (form.getAttribute('data-ajax-cart') === 'false') return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"], [name="add"]');
    if (submitBtn) submitBtn.disabled = true;
    addToCartFromForm(form)
      .catch(function (err) {
        /* Never silent-fallback to form.submit() after a partial success path. */
        var msg =
          err && err.message === 'missing_variant_id'
            ? ((KS.strings && KS.strings.cartError) || 'Unable to add this product. Please try again.')
            : ((KS.strings && KS.strings.cartError) || 'Something went wrong. Please try again.');
        showToast(msg);
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  syncSavedUI();
  updateShippingBar(KS.cartTotal || 0);

  function savedString(key, fallback) {
    return (KS.strings && KS.strings[key]) || fallback;
  }

  var toastTimer = null;

  function showToast(message) {
    if (!message) return;
    var toast = qs('[data-ks-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ks-toast';
      toast.setAttribute('data-ks-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3200);
  }

  document.addEventListener('click', function (e) {
    var el = clickEl(e);
    if (!el) return;

    var btn = el.closest('[data-wishlist-toggle], [data-wishlist-add], [data-compare-toggle]');
    if (!btn) return;

    var name = btn.hasAttribute('data-compare-toggle') ? 'compare' : 'wishlist';
    var handle = savedHandleOf(btn, name);
    if (!handle) return;

    // These controls sit inside product-card links and forms.
    e.preventDefault();
    e.stopPropagation();

    var result = toggleSaved(name, handle);

    if (result.state === 'limit') {
      showToast(
        savedString('compareLimit', 'You can compare up to 4 products. Remove one to add another.').replace(
          '{{ limit }}',
          result.limit
        )
      );
    } else if (name === 'compare') {
      showToast(
        result.state === 'added'
          ? savedString('compareAdded', 'Added to compare.')
          : savedString('compareRemoved', 'Removed from compare.')
      );
      if (result.state === 'added') preloadCompareHandles([handle]);
    }

    syncSavedUI();
    document.dispatchEvent(
      new CustomEvent('ks:saved-change', { detail: { list: name, handle: handle, state: result.state } })
    );
  });

  // Clear Wishlist / Clear Compare List on their dedicated pages.
  document.addEventListener('click', function (e) {
    var el = clickEl(e);
    if (!el) return;
    var clearBtn = el.closest('[data-saved-clear]');
    if (!clearBtn) return;
    var page = clearBtn.closest('[data-saved-page]');
    if (!page) return;
    var name = page.getAttribute('data-saved-page');
    if (!SAVED_LISTS[name]) return;
    e.preventDefault();
    clearSaved(name);
    syncSavedUI();
    document.dispatchEvent(
      new CustomEvent('ks:saved-change', { detail: { list: name, handle: null, state: 'cleared' } })
    );
  });

  // Keep every open tab in step with localStorage.
  window.addEventListener('storage', function (e) {
    if (!e.key || e.key === 'ks_wishlist' || e.key === 'ks_compare') syncSavedUI();
  });

  window.KS.wishlist = {
    items: function () { return readSaved('wishlist'); },
    has: function (handle) { return readSaved('wishlist').indexOf(handle) > -1; },
    toggle: function (handle) {
      var r = toggleSaved('wishlist', handle);
      syncSavedUI();
      return r;
    },
    clear: function () {
      var r = clearSaved('wishlist');
      syncSavedUI();
      document.dispatchEvent(
        new CustomEvent('ks:saved-change', { detail: { list: 'wishlist', handle: null, state: 'cleared' } })
      );
      return r;
    }
  };

  window.KS.compare = {
    limit: SAVED_LISTS.compare.limit,
    items: function () { return readSaved('compare'); },
    has: function (handle) { return readSaved('compare').indexOf(handle) > -1; },
    toggle: function (handle) {
      var r = toggleSaved('compare', handle);
      syncSavedUI();
      return r;
    },
    clear: function () {
      var r = clearSaved('compare');
      syncSavedUI();
      document.dispatchEvent(
        new CustomEvent('ks:saved-change', { detail: { list: 'compare', handle: null, state: 'cleared' } })
      );
      return r;
    }
  };

  /* ---------------------------------------------------------------- *
   * Saved product resolution — always re-read from the Shopify catalog
   * ---------------------------------------------------------------- */
  function shopRoot() {
    var root = (KS.routes && KS.routes.root_url) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function productUrlFor(handle) {
    if (!isProductHandle(handle)) return shopRoot() + 'products/';
    return shopRoot() + 'products/' + encodeURIComponent(handle);
  }

  /**
   * Preserve draft-theme preview context on same-origin fetches.
   * Without preview_theme_id / preview cookies, unpublished draft templates
   * (including compare-data) are not used — the live theme is.
   */
  function withStorefrontPreviewParams(url) {
    try {
      var abs = new URL(url, window.location.origin);
      var cur = new URL(window.location.href);
      ['preview_theme_id', 'preview_theme', '_ab', '_fd', '_sc', 'pb'].forEach(function (key) {
        var val = cur.searchParams.get(key);
        if (val != null && val !== '' && !abs.searchParams.has(key)) {
          abs.searchParams.set(key, val);
        }
      });
      return abs.pathname + abs.search + abs.hash;
    } catch (e) {
      return url;
    }
  }

  /** Extract a Compare product object from raw text (pure JSON or HTML-wrapped). */
  function parseCompareProductPayload(text) {
    if (!text || typeof text !== 'string') return null;
    var trimmed = text.replace(/^\uFEFF/, '').trim();
    var data = null;
    try {
      data = JSON.parse(trimmed);
    } catch (e) {
      data = null;
    }
    if (!(data && data.handle && isProductHandle(data.handle))) {
      data = null;
      /* Anchor on "id": (first field) so braces inside description strings are ignored. */
      var idProbe = trimmed.indexOf('"id":');
      var probe = idProbe > -1 ? idProbe : trimmed.indexOf('"handle"');
      if (probe < 0) probe = trimmed.indexOf('"compare_specs"');
      if (probe > -1) {
        var start = trimmed.lastIndexOf('{', probe);
        if (start > -1) {
          var depth = 0;
          var inString = false;
          var escape = false;
          var end = -1;
          var i;
          for (i = start; i < trimmed.length; i++) {
            var ch = trimmed.charAt(i);
            if (inString) {
              if (escape) escape = false;
              else if (ch === '\\') escape = true;
              else if (ch === '"') inString = false;
              continue;
            }
            if (ch === '"') {
              inString = true;
              continue;
            }
            if (ch === '{') depth++;
            else if (ch === '}') {
              depth--;
              if (depth === 0) {
                end = i;
                break;
              }
            }
          }
          if (end > start) {
            try {
              data = JSON.parse(trimmed.slice(start, end + 1));
            } catch (e2) {
              data = null;
            }
          }
        }
      }
    }
    if (data && data.handle && isProductHandle(data.handle)) return data;
    return null;
  }

  var productCache = {};
  var compareProductCache = {};
  var COMPARE_CACHE_KEY = 'ks_compare_product_cache_v3';

  function readCompareDiskCache() {
    try {
      var raw = sessionStorage.getItem(COMPARE_CACHE_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function writeCompareDiskCache(map) {
    try {
      sessionStorage.setItem(COMPARE_CACHE_KEY, JSON.stringify(map));
    } catch (e) {
      /* quota — ignore */
    }
  }

  function normalizeCompareProduct(data) {
    if (!data || !data.handle || !isProductHandle(data.handle)) return null;
    var fi = data.featured_image;
    if (fi && typeof fi === 'object') fi = fi.src || fi.url || '';
    if (typeof fi !== 'string') fi = '';
    if (fi && !data.image_400) {
      data.image_320 = cdnImage(fi, 320);
      data.image_400 = cdnImage(fi, 400);
      data.image_640 = cdnImage(fi, 640);
    }
    if (data.image_400) data.featured_image = data.image_400;
    else if (fi) data.featured_image = cdnImage(fi, 400) || fi;
    return data;
  }

  /** Cache only Compare fields — never full product.js / description HTML. */
  function leanCompareProduct(product) {
    product = normalizeCompareProduct(product);
    if (!product) return null;
    var v0 = product.variants && product.variants[0];
    var lean = {
      id: product.id,
      handle: product.handle,
      title: product.title,
      vendor: product.vendor || '',
      type: product.type || '',
      tags: product.tags || [],
      available: !!product.available,
      price: product.price != null ? product.price : v0 ? v0.price : null,
      compare_at_price:
        product.compare_at_price != null
          ? product.compare_at_price
          : v0 && v0.compare_at_price
            ? v0.compare_at_price
            : null,
      featured_image: product.featured_image || null,
      image_320: product.image_320 || null,
      image_400: product.image_400 || null,
      image_640: product.image_640 || null,
      url: product.url || '',
      options: product.options || [],
      variants: v0
        ? [
            {
              id: v0.id,
              sku: v0.sku,
              available: v0.available,
              price: v0.price,
              compare_at_price: v0.compare_at_price || null
            }
          ]
        : [],
      compare_specs: product.compare_specs != null ? String(product.compare_specs) : ''
    };
    if (!lean.compare_specs && product.description) {
      lean.description = product.description;
    }
    return lean;
  }

  function rememberCompareProduct(product) {
    var lean = leanCompareProduct(product);
    if (!lean || !lean.handle) return product;
    var disk = readCompareDiskCache();
    disk[lean.handle] = {
      v: 2,
      savedAt: Date.now(),
      product: lean
    };
    writeCompareDiskCache(disk);
    return lean;
  }

  function cachedCompareProduct(handle) {
    if (!isProductHandle(handle)) return null;
    var disk = readCompareDiskCache();
    var entry = disk[handle];
    if (!entry || !entry.product || !entry.product.handle) return null;
    /* 30 minutes */
    if (Date.now() - (entry.savedAt || 0) > 30 * 60 * 1000) return null;
    return normalizeCompareProduct(entry.product);
  }

  function fetchProduct(handle) {
    if (!isProductHandle(handle)) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetch(productUrlFor(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('unresolved');
          return r.json();
        })
        .then(function (data) {
          return data && data.handle ? data : null;
        })
        .catch(function () {
          delete productCache[handle];
          return null;
        });
    }
    return productCache[handle];
  }

  /**
   * Compare products need custom.compare_specs (not on /products/*.js).
   * Memory cache → sessionStorage → Section API → view → product.js
   */
  function fetchCompareProduct(handle, opts) {
    if (!isProductHandle(handle)) return Promise.resolve(null);
    opts = opts || {};

    if (!opts.bypassCache && compareProductCache[handle]) {
      return compareProductCache[handle];
    }

    if (!opts.bypassCache) {
      var warm = cachedCompareProduct(handle);
      if (warm) {
        compareProductCache[handle] = Promise.resolve(warm);
        var disk = readCompareDiskCache();
        var age = Date.now() - ((disk[handle] && disk[handle].savedAt) || 0);
        /* Soft-refresh only when cache is older than 60s — avoids racing first paint. */
        if (age > 60 * 1000) {
          setTimeout(function () {
            fetchCompareProduct(handle, { bypassCache: true }).catch(function () {});
          }, 0);
        }
        return compareProductCache[handle];
      }
    }

    var base = productUrlFor(handle);
    var sectionUrl = withStorefrontPreviewParams(base + '?sections=ks-compare-product-data');
    var viewUrl = withStorefrontPreviewParams(base + '?view=compare-data');

    var pending = fetch(sectionUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('section-http');
        return r.json();
      })
      .then(function (sections) {
        var html = sections && sections['ks-compare-product-data'];
        if (!html || typeof html !== 'string') throw new Error('section-empty');
        var data = parseCompareProductPayload(html);
        if (!data) throw new Error('section-parse');
        return data;
      })
      .catch(function () {
        return fetch(viewUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json, text/plain, */*' }
        })
          .then(function (r) {
            if (!r.ok) throw new Error('view-http');
            return r.text();
          })
          .then(function (text) {
            var data = parseCompareProductPayload(text);
            if (!data) throw new Error('view-parse');
            return data;
          });
      })
      .catch(function () {
        return fetchProduct(handle);
      })
      .then(function (data) {
        data = normalizeCompareProduct(data);
        if (!data || !data.handle) {
          delete compareProductCache[handle];
          return null;
        }
        return rememberCompareProduct(data);
      })
      .catch(function () {
        delete compareProductCache[handle];
        return null;
      });

    compareProductCache[handle] = pending;
    return pending;
  }

  function preloadCompareHandles(handles) {
    (handles || []).forEach(function (handle) {
      if (!isProductHandle(handle)) return;
      fetchCompareProduct(handle).catch(function () {});
    });
  }

  function resolveSaved(name) {
    var handles = readSaved(name);
    if (!handles.length) return Promise.resolve({ items: [], missing: [] });

    var loader = name === 'compare' ? fetchCompareProduct : fetchProduct;
    return Promise.all(handles.map(loader)).then(function (products) {
      var items = [];
      var missing = [];
      handles.forEach(function (handle, i) {
        if (products[i]) items.push(products[i]);
        else missing.push(handle);
      });
      // Don't auto-remove handles from storage — the fetch may have failed
      // due to network issues or a local preview without a Shopify catalog.
      // Handles remain saved so they resolve correctly once the store is live.
      return { items: items, missing: missing };
    });
  }

  var ICONS = {
    wishlist:
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 20.5s-7-4.6-7-10a4 4 0 0 1 7-2.5 4 4 0 0 1 7 2.5c0 5.4-7 10-7 10z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
    close:
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    cart:
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6h15l-1.5 9h-12z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="9" cy="20" r="1.4" fill="currentColor"/><circle cx="18" cy="20" r="1.4" fill="currentColor"/><path d="M6 6L5 3H2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
  };

  function cdnImage(url, width) {
    if (!isSafeHttpUrl(url)) return '';
    try {
      var abs = new URL(url, window.location.origin);
      if (width) abs.searchParams.set('width', String(width));
      return abs.href;
    } catch (e) {
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      return url + sep + 'width=' + width;
    }
  }

  function compareImageAttrs(product) {
    var src =
      product.image_400 ||
      product.featured_image ||
      product.image_320 ||
      '';
    if (src && typeof src === 'object') src = src.src || src.url || '';
    if (!src || typeof src !== 'string') src = '';
    var src320 = product.image_320 || (src ? cdnImage(src, 320) : '');
    var src400 = product.image_400 || (src ? cdnImage(src, 400) : '');
    var src640 = product.image_640 || (src ? cdnImage(src, 640) : '');
    return {
      src: src400 || src320 || src,
      srcset:
        src320 && src400 && src640
          ? src320 + ' 320w, ' + src400 + ' 400w, ' + src640 + ' 640w'
          : '',
      /* Displayed column ≈ 8.5–11rem; avoid requesting original assets. */
      sizes: '(max-width: 749px) 136px, 176px'
    };
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  // Rebuilds the approved .product-card markup from live Shopify product JSON.
  function savedProductCard(product) {
    var url = productUrlFor(product.handle);
    var card = el('article', 'product-card');

    var media = el('div', 'product-card__media');

    var actions = el('div', 'product-card__quick-actions');
    var remove = el('button', 'product-card__quick-btn is-active');
    remove.type = 'button';
    remove.setAttribute('data-wishlist-toggle', product.handle);
    remove.setAttribute('aria-pressed', 'true');
    remove.setAttribute('aria-label', savedString('wishlistRemove', 'Remove from wishlist'));
    remove.innerHTML = ICONS.wishlist;
    actions.appendChild(remove);
    media.appendChild(actions);

    var link = el('a');
    link.href = url;
    link.setAttribute('aria-label', product.title);
    if (product.featured_image) {
      var img = el('img');
      img.src = cdnImage(product.featured_image, 600);
      img.alt = product.title;
      img.loading = 'lazy';
      link.appendChild(img);
    } else {
      link.appendChild(el('div', 'product-card__placeholder', savedString('imagePlaceholder', 'Product image')));
    }
    media.appendChild(link);

    var badges = el('div', 'product-card__badges');
    if (product.compare_at_price && product.compare_at_price > product.price && !productIsCallForPrice(product)) {
      badges.appendChild(el('span', 'product-card__badge product-card__badge--sale', savedString('onSale', 'Sale')));
    }
    if (!product.available && !productIsCallForPrice(product)) {
      badges.appendChild(el('span', 'product-card__badge product-card__badge--sold', savedString('soldOut', 'Sold out')));
    }
    media.appendChild(badges);
    card.appendChild(media);

    var body = el('div', 'product-card__body');
    if (product.vendor) body.appendChild(el('p', 'product-card__vendor', product.vendor));

    var title = el('h3', 'product-card__title');
    var titleLink = el('a', null, product.title);
    titleLink.href = url;
    title.appendChild(titleLink);
    body.appendChild(title);

    var priceRow = el('div', 'product-card__price-row');
    var isCfp = productIsCallForPrice(product);
    var onSale = !isCfp && product.compare_at_price && product.compare_at_price > product.price;
    var price = el('div', 'price' + (onSale ? ' price--on-sale' : ''));
    if (isCfp) {
      price.setAttribute('data-call-for-price', 'true');
      price.appendChild(el('span', 'price__regular', callForPriceLabel()));
    } else {
      price.appendChild(el('span', 'price__regular', formatMoney(product.price)));
      if (onSale) {
        price.appendChild(el('s', 'price__compare', formatMoney(product.compare_at_price)));
      }
    }
    priceRow.appendChild(price);
    if (!isCfp && product.available) {
      priceRow.appendChild(el('span', 'product-card__stock', savedString('inStock', 'In Stock')));
    }
    body.appendChild(priceRow);

    var cardActions = el('div', 'product-card__actions');
    if (isCfp) {
      var cfpLink = el('a', 'btn btn--sm btn--full', callForPriceLabel());
      cfpLink.href = url;
      cardActions.appendChild(cfpLink);
    } else {
      var firstAvailable = null;
      if (product.variants && product.variants.length) {
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].available) {
            firstAvailable = product.variants[i];
            break;
          }
        }
      }
      if (firstAvailable) {
        var form = el('form', 'product-card__form');
        form.method = 'post';
        form.action = cartRoute('cart_add_url', '/cart/add');
        var idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        idInput.value = String(firstAvailable.id);
        form.appendChild(idInput);
        var qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.value = '1';
        form.appendChild(qtyInput);
        var addBtn = el('button', 'btn btn--sm btn--full');
        addBtn.type = 'submit';
        addBtn.name = 'add';
        addBtn.innerHTML = ICONS.cart;
        addBtn.appendChild(document.createTextNode(' ' + savedString('addToCart', 'Add to Cart')));
        form.appendChild(addBtn);
        cardActions.appendChild(form);
      } else {
        var view = el('a', 'btn btn--sm btn--full btn--dark', savedString('viewDetails', 'View details'));
        view.href = url;
        cardActions.appendChild(view);
      }
    }
    body.appendChild(cardActions);

    card.appendChild(body);
    return card;
  }

  var renderSeq = 0;

  function renderSavedPage(root) {
    var name = root.getAttribute('data-saved-page');
    if (!SAVED_LISTS[name]) return;

    var loading = qs('[data-saved-loading]', root);
    var grid = qs('[data-saved-grid]', root);
    var empty = qs('[data-saved-empty]', root);
    var notice = qs('[data-saved-notice]', root);
    var summary = qs('[data-saved-summary]', root);
    var clearBtn = qs('[data-saved-clear]', root);

    function syncClearVisibility() {
      if (!clearBtn) return;
      // Visibility follows the saved handle list, not resolved products.
      clearBtn.hidden = readSaved(name).length === 0;
    }

    function updateSummary() {
      if (!summary) return;
      var storedCount = readSaved(name).length;
      if (storedCount) {
        summary.textContent = storedCount + ' ' + (storedCount === 1 ? 'product' : 'products');
        summary.hidden = false;
      } else {
        summary.hidden = true;
      }
    }

    function paintSavedItems(items) {
      if (!grid) return;
      if (empty) empty.hidden = true;
      grid.textContent = '';
      if (name === 'compare') grid.appendChild(compareTable(items));
      else {
        items.forEach(function (product) {
          grid.appendChild(savedProductCard(product));
        });
      }
      grid.hidden = false;
    }

    syncClearVisibility();
    updateSummary();
    if (notice) notice.hidden = true;

    // Rapid toggles queue several async renders; only the newest may paint,
    // otherwise a slower earlier render can overwrite the current state.
    var token = ++renderSeq;
    root.ksRenderToken = token;

    /* Progressive: paint warm session cache immediately (headers + specs),
       then refresh when network resolves — images decode async and never block. */
    var paintedWarm = false;
    if (name === 'compare' && grid) {
      var warmItems = [];
      readSaved(name).forEach(function (handle) {
        var warm = cachedCompareProduct(handle);
        if (warm) warmItems.push(warm);
      });
      if (warmItems.length) {
        if (loading) loading.hidden = true;
        paintSavedItems(warmItems);
        paintedWarm = true;
        syncSavedUI();
      }
    }

    if (!paintedWarm && loading) loading.hidden = false;

    resolveSaved(name).then(function (res) {
      if (root.ksRenderToken !== token) return;
      if (loading) loading.hidden = true;
      syncClearVisibility();
      updateSummary();

      if (res.missing.length && notice) {
        notice.textContent = res.items.length
          ? savedString('savedUnavailable', 'Some saved products are no longer available.')
          : savedString(
              'savedLoadFailed',
              'Saved products could not be loaded right now. Please refresh and try again.'
            );
        notice.hidden = false;
      }

      if (!res.items.length) {
        if (grid) {
          grid.textContent = '';
          grid.hidden = true;
        }
        if (empty) empty.hidden = false;
        syncSavedUI();
        return;
      }

      paintSavedItems(res.items);
      syncSavedUI();
    });
  }

  function stripHtml(html) {
    if (!html) return '';
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  }

  /** Pull Key Features / specs list from product.description HTML (data-ks-specs). Legacy only. */
  function extractProductSpecs(html) {
    if (!html) return [];
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var list = tmp.querySelector('[data-ks-specs]');
    if (!list) return [];
    return Array.from(list.querySelectorAll('li'))
      .map(function (li) {
        return (li.textContent || '').replace(/\s+/g, ' ').trim();
      })
      .filter(Boolean);
  }

  /**
   * Parse Admin multiline compare_specs (preferred) or legacy description list.
   * One "Label: Value" per line — only the first colon splits label/value.
   */
  function extractCompareSpecLines(product) {
    if (!product) return [];
    var raw = product.compare_specs;
    if (raw != null && String(raw).trim() !== '') {
      var text = String(raw);
      /* Prefer real newlines; tolerate accidental literal \n from some Admin imports. */
      if (text.indexOf('\n') === -1 && text.indexOf('\\n') > -1) {
        text = text.split('\\n').join('\n');
      }
      return text
        .split(/\r?\n/)
        .map(function (line) {
          return String(line).replace(/\s+/g, ' ').trim();
        })
        .filter(Boolean);
    }
    /* Migration fallback only when metafield is empty. */
    return extractProductSpecs(product.description);
  }

  /**
   * Parse "Label: value" lines into { label, value }.
   * Lines without a colon keep the full text as label with value "Yes".
   */
  function parseSpecLine(line) {
    if (!line) return null;
    var text = String(line).replace(/\s+/g, ' ').trim();
    if (!text) return null;
    var idx = text.indexOf(':');
    if (idx > 0 && idx < text.length - 1) {
      return {
        label: text.slice(0, idx).trim(),
        value: text.slice(idx + 1).trim()
      };
    }
    return { label: text, value: 'Yes' };
  }

  /**
   * Canonicalize harmless label variants so Compare aligns the same field.
   * Does NOT merge genuinely different specs (e.g. Resolution vs Recording Resolution).
   * Central alias map — no SKU-specific hard-coding.
   */
  function canonicalizeSpecLabel(label) {
    var raw = String(label || '').replace(/\s+/g, ' ').trim();
    var key = raw
      .toLowerCase()
      .replace(/[.:]+$/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    var aliases = {
      'human detection': 'Human detection support',
      'human detection support': 'Human detection support',
      'smd (human)': 'Human detection support',
      'smd human': 'Human detection support',
      'built-in mic': 'Built-in microphone',
      'built in microphone': 'Built-in microphone',
      'builtin microphone': 'Built-in microphone',
      'built-in microphone': 'Built-in microphone',
      'built-in mic + speaker': 'Built-in mic + speaker',
      'smart dual light': 'Smart Dual Light',
      'smart dual-light': 'Smart Dual Light',
      'smart dual light (ir + warm light)': 'Smart Dual Light',
      'protection rating': 'Protection',
      'ingress protection': 'Protection',
      'ip rating': 'Protection',
      'power supply': 'Power',
      'power input': 'Power',
      'video compression': 'Codec',
      'compression': 'Codec',
      'max. resolution': 'Resolution',
      'max resolution': 'Resolution',
      'image resolution': 'Resolution',
      'frame rate': 'Frame rate',
      'max. frame rate': 'Max. frame rate',
      'max frame rate': 'Max. frame rate'
    };
    if (aliases[key]) return aliases[key];
    /* Title-case-ish preserve original casing after whitespace normalize. */
    return raw;
  }

  /** Map of normalized-label → { label, value } for one product. */
  function productSpecMap(product) {
    var map = {};
    extractCompareSpecLines(product).forEach(function (line) {
      var parsed = parseSpecLine(line);
      if (!parsed || !parsed.label) return;
      var canonical = canonicalizeSpecLabel(parsed.label);
      var key = canonical.toLowerCase();
      if (!map[key]) map[key] = { label: canonical, value: parsed.value };
    });
    return map;
  }

  function isMeaninglessOptionName(name) {
    return /^title$/i.test(String(name || '').trim());
  }

  function isMeaninglessOptionValue(value) {
    return /^default(\s+title)?$/i.test(String(value || '').trim());
  }

  function productModel(product) {
    if (!product) return '';
    var variants = product.variants || [];
    var i;
    for (i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].sku) return String(variants[i].sku);
    }
    return '';
  }

  function canonicalizeSpecValue(value) {
    return String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .replace(/[–—]/g, '-')
      .trim()
      .toLowerCase();
  }

  function valuesDiffer(values) {
    var norms = values.map(canonicalizeSpecValue);
    var first = norms[0];
    for (var i = 1; i < norms.length; i++) {
      if (norms[i] !== first) return true;
    }
    return false;
  }

  function compareRow(label) {
    var tr = el('tr');
    tr.appendChild(el('th', 'compare-table__label', label));
    return tr;
  }

  function appendCompareCells(row, values) {
    var differ = values.length > 1 && valuesDiffer(values);
    values.forEach(function (text) {
      var raw = text == null ? '' : String(text).trim();
      var has = raw && raw !== '—';
      var cls = [];
      if (!has) cls.push('compare-table__muted');
      if (differ) cls.push('compare-table__diff');
      row.appendChild(el('td', cls.length ? cls.join(' ') : null, has ? raw : '—'));
    });
  }

  function compareTable(items) {
    var wrap = el('div', 'compare-table__scroll');
    var table = el('table', 'compare-table');
    var thead = el('thead');

    function cornerCell(extraClass, text) {
      return el(
        'th',
        'compare-table__label compare-table__corner' + (extraClass ? ' ' + extraClass : ''),
        text || ''
      );
    }

    /* Split product header into rows so the left label column does not stretch
       to the full image+title+price height (that created a huge empty block). */
    var removeRow = el('tr', 'compare-table__row--actions');
    removeRow.appendChild(cornerCell('compare-table__corner--empty', ''));
    items.forEach(function (product) {
      var th = el('th', 'compare-table__product compare-table__product--actions');
      var remove = el('button', 'compare-table__remove');
      remove.type = 'button';
      remove.setAttribute('data-compare-toggle', product.handle);
      remove.setAttribute('aria-pressed', 'true');
      remove.setAttribute('aria-label', savedString('compareRemove', 'Remove from compare') + ': ' + product.title);
      remove.innerHTML = ICONS.close;
      th.appendChild(remove);
      removeRow.appendChild(th);
    });
    thead.appendChild(removeRow);

    var imageRow = el('tr', 'compare-table__row--images');
    imageRow.appendChild(cornerCell('compare-table__corner--empty', ''));
    items.forEach(function (product) {
      var th = el('th', 'compare-table__product compare-table__product--media');
      var url = productUrlFor(product.handle);
      var link = el('a', 'compare-table__media');
      link.href = url;
      var attrs = compareImageAttrs(product);
      if (attrs.src && isSafeHttpUrl(attrs.src)) {
        var img = el('img');
        img.src = attrs.src;
        if (attrs.srcset) img.srcset = attrs.srcset;
        if (attrs.sizes) img.sizes = attrs.sizes;
        img.alt = product.title || '';
        img.width = 400;
        img.height = 400;
        img.decoding = 'async';
        img.loading = 'eager';
        img.setAttribute('fetchpriority', 'low');
        link.appendChild(img);
      } else {
        link.appendChild(el('span', 'product-card__placeholder', savedString('imagePlaceholder', 'Product image')));
      }
      th.appendChild(link);
      imageRow.appendChild(th);
    });
    thead.appendChild(imageRow);

    var titleRow = el('tr', 'compare-table__row--title');
    titleRow.appendChild(el('th', 'compare-table__label', savedString('compareProduct', 'Product')));
    items.forEach(function (product) {
      var th = el('th', 'compare-table__product');
      var title = el('a', 'compare-table__title', product.title);
      title.href = productUrlFor(product.handle);
      th.appendChild(title);
      titleRow.appendChild(th);
    });
    thead.appendChild(titleRow);

    var modelRow = el('tr', 'compare-table__row--meta');
    modelRow.appendChild(cornerCell('compare-table__corner--empty', ''));
    var anyModel = false;
    items.forEach(function (product) {
      var th = el('th', 'compare-table__product');
      var model = productModel(product);
      if (model) {
        anyModel = true;
        th.appendChild(el('p', 'compare-table__meta', savedString('compareModel', 'Model') + ': ' + model));
      }
      modelRow.appendChild(th);
    });
    if (anyModel) thead.appendChild(modelRow);

    var priceRow = el('tr', 'compare-table__row--price');
    priceRow.appendChild(cornerCell('compare-table__corner--empty', ''));
    items.forEach(function (product) {
      var th = el('th', 'compare-table__product');
      var priceWrap = el('div', 'compare-table__price');
      if (productIsCallForPrice(product)) {
        priceWrap.appendChild(el('strong', null, callForPriceLabel()));
      } else {
        priceWrap.appendChild(el('strong', null, formatMoney(product.price)));
        if (product.compare_at_price && product.compare_at_price > product.price) {
          priceWrap.appendChild(el('s', 'price__compare', formatMoney(product.compare_at_price)));
        }
      }
      th.appendChild(priceWrap);
      priceRow.appendChild(th);
    });
    thead.appendChild(priceRow);

    var stockRow = el('tr', 'compare-table__row--stock');
    stockRow.appendChild(cornerCell('compare-table__corner--empty', ''));
    items.forEach(function (product) {
      var th = el('th', 'compare-table__product');
      th.appendChild(
        el(
          'p',
          product.available ? 'compare-table__in' : 'compare-table__out',
          product.available ? savedString('inStock', 'In Stock') : savedString('soldOut', 'Sold out')
        )
      );
      stockRow.appendChild(th);
    });
    thead.appendChild(stockRow);

    table.appendChild(thead);

    var tbody = el('tbody');

    function appendTextRow(label, getter) {
      var values = items.map(function (product) {
        var value = getter(product);
        return value && String(value).trim() ? String(value).trim() : '';
      });
      var any = values.some(Boolean);
      if (!any) return;
      var row = compareRow(label);
      appendCompareCells(
        row,
        values.map(function (v) {
          return v || '—';
        })
      );
      tbody.appendChild(row);
    }

    /* Compact identity rows (not description). Title/price live in the header. */
    appendTextRow(savedString('compareBrand', 'Brand'), function (p) { return p.vendor; });
    appendTextRow(savedString('compareType', 'Product Type'), function (p) { return p.type; });

    /* Real variant options only — never Title / Default. */
    var optionNames = [];
    items.forEach(function (product) {
      (product.options || []).forEach(function (opt) {
        var name = typeof opt === 'string' ? opt : opt && opt.name;
        if (!name || isMeaninglessOptionName(name)) return;
        if (optionNames.indexOf(name) === -1) optionNames.push(name);
      });
    });
    optionNames.forEach(function (optName) {
      var cellValues = [];
      var anyReal = false;
      items.forEach(function (product) {
        var values = [];
        var opts = product.options || [];
        var oi;
        for (oi = 0; oi < opts.length; oi++) {
          var o = opts[oi];
          var n = typeof o === 'string' ? o : o && o.name;
          if (n === optName) {
            if (typeof o === 'object' && o.values) values = o.values;
            else if (product.variants && product.variants.length) {
              values = product.variants
                .map(function (v) {
                  return v['option' + (oi + 1)];
                })
                .filter(Boolean);
            }
            break;
          }
        }
        var unique = [];
        values.forEach(function (v) {
          if (!v || isMeaninglessOptionValue(v)) return;
          if (unique.indexOf(v) === -1) unique.push(v);
        });
        if (unique.length) anyReal = true;
        cellValues.push(unique.length ? unique.join(', ') : '—');
      });
      if (!anyReal) return;
      var optRow = compareRow(optName);
      appendCompareCells(optRow, cellValues);
      tbody.appendChild(optRow);
    });

    /* Spec maps → union of labels as side-by-side rows (main purpose of this page). */
    var specMaps = items.map(productSpecMap);
    var labelOrder = [];
    var labelSeen = {};
    specMaps.forEach(function (map) {
      Object.keys(map).forEach(function (key) {
        if (labelSeen[key]) return;
        labelSeen[key] = true;
        labelOrder.push(map[key].label);
      });
    });

    if (labelOrder.length) {
      var sectionRow = el('tr', 'compare-table__section');
      var sectionTh = el('th', 'compare-table__section-label');
      sectionTh.colSpan = items.length + 1;
      sectionTh.textContent = savedString('compareSpecs', 'Specifications / Key Features');
      sectionRow.appendChild(sectionTh);
      tbody.appendChild(sectionRow);

      labelOrder.forEach(function (label) {
        var key = label.toLowerCase();
        var row = compareRow(label);
        var cellValues = items.map(function (_product, i) {
          var entry = specMaps[i][key];
          return entry && entry.value ? entry.value : '—';
        });
        appendCompareCells(row, cellValues);
        tbody.appendChild(row);
      });
    } else {
      var emptySpecs = compareRow(savedString('compareSpecs', 'Specifications / Key Features'));
      items.forEach(function () {
        emptySpecs.appendChild(
          el(
            'td',
            'compare-table__muted',
            savedString('compareSpecsMissing', 'Specifications are not available for this product yet.')
          )
        );
      });
      tbody.appendChild(emptySpecs);
    }

    var linkRow = compareRow('');
    items.forEach(function (product) {
      var td = el('td');
      var a = el('a', 'btn btn--sm btn--full btn--dark', savedString('viewDetails', 'View details'));
      a.href = productUrlFor(product.handle);
      td.appendChild(a);
      linkRow.appendChild(td);
    });
    tbody.appendChild(linkRow);

    table.appendChild(tbody);
    wrap.appendChild(table);
    return wrap;
  }

  qsa('[data-saved-page]').forEach(renderSavedPage);
  /* Preload compare product payloads only on compare/wishlist pages.
     Global idle preload competed with homepage/collection images on every visit. */
  (function () {
    var path = (window.location && window.location.pathname) || '';
    var onSavedPage = !!qs('[data-saved-page]');
    var needsCompareWarm =
      onSavedPage || /\/pages\/(compare|wishlist)/i.test(path);
    if (!needsCompareWarm) return;
    function warmCompare() {
      preloadCompareHandles(readSaved('compare'));
    }
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(warmCompare, { timeout: 2500 });
    } else {
      setTimeout(warmCompare, 1200);
    }
  })();

  document.addEventListener('ks:saved-change', function (e) {
    qsa('[data-saved-page]').forEach(function (root) {
      // Re-render the page a customer is standing on when its own list changes.
      if (root.getAttribute('data-saved-page') === e.detail.list) renderSavedPage(root);
    });
  });

  qsa('[data-featured-tabs]').forEach(function (section) {
    if (section.getAttribute('data-featured-bound') === 'true') return;
    section.setAttribute('data-featured-bound', 'true');

    var triggers = qsa('[data-tab-trigger]', section);
    var panels = qsa('[data-tab-panel]', section);
    var viewAll = qs('[data-featured-view-all]', section);
    if (!triggers.length) return;

    var current = 0;
    var timer = null;
    var intervalMs = 3000;
    var userPaused = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function activate(index, fromUser) {
      if (!triggers.length) return;
      current = ((index % triggers.length) + triggers.length) % triggers.length;
      var trigger = triggers[current];
      var targetId = trigger.getAttribute('data-tab-trigger');
      var tabUrl = trigger.getAttribute('data-tab-view-all');

      triggers.forEach(function (t, i) {
        var on = i === current;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var on = panel.id === targetId;
        panel.hidden = !on;
        panel.classList.toggle('is-active', on);
      });
      if (viewAll && tabUrl) viewAll.setAttribute('href', tabUrl);

      /* Manual tab click: keep selection and stop autoplay for this page session. */
      if (fromUser) {
        userPaused = true;
        stopTimer();
      }
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      stopTimer();
      if (userPaused) return;
      if (reducedMotion) return;
      if (triggers.length < 2) return;
      if (document.visibilityState === 'hidden') return;
      timer = setInterval(function () {
        activate(current + 1, false);
      }, intervalMs);
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        activate(index, true);
      });
    });

    /* Sync index with server-rendered active tab (Deals first). */
    triggers.forEach(function (trigger, index) {
      if (trigger.classList.contains('is-active') || trigger.getAttribute('aria-selected') === 'true') {
        current = index;
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') stopTimer();
      else if (!userPaused) startTimer();
    });

    startTimer();
  });

  qsa('[data-trust-ticker]').forEach(function (track) {
    var viewport = track.parentElement;
    if (!viewport) return;

    track.addEventListener('mouseenter', function () {
      track.classList.add('is-paused');
    });
    track.addEventListener('mouseleave', function () {
      track.classList.remove('is-paused');
    });
    track.addEventListener('focusin', function () {
      track.classList.add('is-paused');
    });
    track.addEventListener('focusout', function () {
      track.classList.remove('is-paused');
    });
  });

  function initHeroCarousel(carousel) {
    if (!carousel || carousel.getAttribute('data-hero-bound') === 'true') return;

    var slides = qsa('[data-hero-slide]', carousel);
    if (slides.length <= 1) return;

    carousel.setAttribute('data-hero-bound', 'true');

    var dots = qsa('[data-hero-dot]', carousel);
    var prevBtn = qs('[data-hero-prev]', carousel);
    var nextBtn = qs('[data-hero-next]', carousel);
    var actions = qs('.hero-actions', carousel);
    var shopBtn = qs('[data-hero-shop]', carousel) || qs('.hero__btn-shop', carousel);
    var current = 0;
    var timer = null;
    var paused = false;
    var resumeTimer = null;
    var transitioning = false;
    var seconds = Number(carousel.getAttribute('data-autoplay')) || 6;
    var interval = Math.max(5000, Math.min(6000, seconds * 1000));
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function slideBanner(slide) {
      return slide ? qs('img.hero__banner', slide) : null;
    }

    function hydrateBanner(img) {
      if (!img) return Promise.resolve();
      var picture = img.parentElement && img.parentElement.tagName === 'PICTURE' ? img.parentElement : null;
      if (picture) {
        qsa('source[data-srcset]', picture).forEach(function (source) {
          source.setAttribute('srcset', source.getAttribute('data-srcset'));
          source.removeAttribute('data-srcset');
        });
      }
      var srcset = img.getAttribute('data-srcset');
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-srcset');
      }
      var url = img.getAttribute('data-src');
      if (!url && !srcset && !(picture && qs('source[srcset]', picture))) return Promise.resolve();
      if (!url) return Promise.resolve();
      if (img.getAttribute('src') === url) {
        img.removeAttribute('data-src');
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        var done = function () {
          img.removeEventListener('load', done);
          img.removeEventListener('error', done);
          img.removeAttribute('data-src');
          resolve();
        };
        img.addEventListener('load', done);
        img.addEventListener('error', done);
        img.setAttribute('src', url);
        if (img.complete) done();
      });
    }

    function ensureSlideImage(index) {
      return hydrateBanner(slideBanner(slides[index]));
    }

    function preloadNext() {
      var nextIndex = (current + 1) % slides.length;
      ensureSlideImage(nextIndex);
    }

    function schedulePreloadNext() {
      /* Delay next-slide bandwidth until Banner 1 has had time to win LCP. */
      var delay = Math.max(2500, interval - 1500);
      var run = function () {
        preloadNext();
      };
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(run, { timeout: delay });
      } else {
        setTimeout(run, delay);
      }
    }

    function applyGoTo(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.classList.toggle('is-active', active);
        slide.removeAttribute('hidden');
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (actions) {
        actions.classList.toggle(
          'hero-actions--zakcom',
          slides[current].classList.contains('hero-carousel__slide--zakcom')
        );
      }
      if (shopBtn) {
        var shopHref = slides[current].getAttribute('data-shop-link');
        if (shopHref) shopBtn.setAttribute('href', shopHref);
      }
      schedulePreloadNext();
    }

    function goTo(index) {
      var target = (index + slides.length) % slides.length;
      if (target === current && !transitioning) return;
      if (transitioning) return;
      transitioning = true;
      ensureSlideImage(target).then(function () {
        applyGoTo(target);
        transitioning = false;
      });
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (paused || reducedMotion) return;
      timer = setInterval(next, interval);
    }

    function pauseAutoplay() {
      paused = true;
      stopAutoplay();
      if (resumeTimer) clearTimeout(resumeTimer);
    }

    function scheduleResume(delay) {
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        paused = false;
        startAutoplay();
      }, delay || 8000);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        pauseAutoplay();
        prev();
        scheduleResume();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        pauseAutoplay();
        next();
        scheduleResume();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        pauseAutoplay();
        goTo(Number(dot.getAttribute('data-hero-dot')));
        scheduleResume();
      });
    });

    carousel.addEventListener('mouseenter', pauseAutoplay);
    carousel.addEventListener('mouseleave', function () {
      paused = false;
      startAutoplay();
    });

    carousel.addEventListener('focusin', pauseAutoplay);
    carousel.addEventListener('focusout', function (e) {
      if (!carousel.contains(e.relatedTarget)) {
        paused = false;
        startAutoplay();
      }
    });

    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        pauseAutoplay();
        prev();
        scheduleResume();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        pauseAutoplay();
        next();
        scheduleResume();
      }
    });

    /* After LCP/slide-1 is ready, idle-preload only the next slide (not all). */
    var firstBanner = slideBanner(slides[0]);
    function afterFirstReady() {
      schedulePreloadNext();
    }
    if (firstBanner && !firstBanner.complete) {
      firstBanner.addEventListener('load', afterFirstReady, { once: true });
      firstBanner.addEventListener('error', afterFirstReady, { once: true });
    } else {
      afterFirstReady();
    }

    startAutoplay();
  }

  qsa('[data-hero-carousel]').forEach(initHeroCarousel);
  initDeferredSectionImages();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root) return;
    qsa('[data-hero-carousel]', root).forEach(function (carousel) {
      carousel.removeAttribute('data-hero-bound');
      initHeroCarousel(carousel);
    });
    initDeferredSectionImages();
    qsa('[data-main-product]', root).forEach(function (el) {
      el.removeAttribute('data-product-bound');
      initProductSection(el);
    });
    initCollectionFacets(root);
  });

  function initProductGallery(root) {
    var stage = qs('[data-media-stage]', root);
    var thumbs = qsa('[data-thumb]', root);
    var mediaTemplatesEl = qs('[data-media-templates]', root);
    if (!stage || !mediaTemplatesEl || thumbs.length < 1) return null;

    var mediaIndex = 0;
    var activeThumb = thumbs.find(function (thumb) {
      return thumb.classList.contains('is-active');
    });
    if (activeThumb) {
      mediaIndex = Number(activeThumb.getAttribute('data-media-index')) || 0;
    }

    function mediaSource() {
      return mediaTemplatesEl.content || mediaTemplatesEl;
    }

    function setActiveThumb(mediaId) {
      thumbs.forEach(function (thumb) {
        var active = String(thumb.getAttribute('data-media-id')) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) mediaIndex = Number(thumb.getAttribute('data-media-index')) || 0;
      });
    }

    function showMedia(mediaId) {
      if (!mediaId) return;
      var template = mediaSource().querySelector('[data-media-template="' + mediaId + '"]');
      if (!template) return;
      stage.innerHTML = template.innerHTML;
      setActiveThumb(mediaId);
    }

    function showMediaByIndex(index) {
      if (!thumbs.length) return;
      var next = ((index % thumbs.length) + thumbs.length) % thumbs.length;
      var thumb = thumbs[next];
      if (thumb) showMedia(thumb.getAttribute('data-media-id'));
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.getAttribute('data-media-id'));
      });
    });

    var prevBtn = qs('[data-media-prev]', root);
    var nextBtn = qs('[data-media-next]', root);
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        showMediaByIndex(mediaIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        showMediaByIndex(mediaIndex + 1);
      });
    }

    return { showMedia: showMedia };
  }

  function initProductSection(root) {
    if (!root || root.getAttribute('data-product-bound') === 'true') return;
    root.setAttribute('data-product-bound', 'true');

    var qtyInput = qs('[data-qty-input]', root);
    if (qtyInput) {
      var decrease = qs('[data-qty-decrease]', root);
      var increase = qs('[data-qty-increase]', root);
      if (decrease) {
        decrease.addEventListener('click', function () {
          var next = Math.max(1, Number(qtyInput.value || 1) - 1);
          qtyInput.value = String(next);
        });
      }
      if (increase) {
        increase.addEventListener('click', function () {
          var next = normalizeAddQuantity((Number(qtyInput.value || 1) || 1) + 1);
          qtyInput.value = String(next);
        });
      }
      qtyInput.addEventListener('change', function () {
        qtyInput.value = String(normalizeAddQuantity(qtyInput.value));
      });
    }

    var gallery = initProductGallery(root);

    var jsonEl = qs('[data-product-json]', root);
    if (!jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var form = qs('[data-product-form]', root);
    var variantInput = qs('[data-variant-id]', root);
    var optionSelects = qsa('[data-option-select]', root);
    var priceWrap = qs('[data-product-price-wrap]', root);
    var availability = qs('[data-product-availability]', root);
    var skuRow = qs('[data-product-sku]', root);
    var skuValue = qs('[data-sku-value]', root);
    var saleBadge = qs('[data-sale-badge]', root);
    var addBtn = qs('[data-add-to-cart]', root);
    var addLabel = qs('[data-add-label]', root);

    var strings = {
      inStock: (KS.strings && KS.strings.inStock) || 'In Stock',
      soldOut: (KS.strings && KS.strings.soldOut) || 'Sold out',
      addToCart: (KS.strings && KS.strings.addToCart) || 'Add to Cart',
      callForPrice: callForPriceLabel()
    };

    var isCallForPrice =
      (root && root.getAttribute('data-call-for-price') === 'true') ||
      productIsCallForPrice(product);

    function getSelectedOptions() {
      return optionSelects.map(function (select) {
        return select.value;
      });
    }

    function findVariant(options) {
      if (!product.variants || !product.variants.length) return null;
      return product.variants.find(function (variant) {
        return options.every(function (value, index) {
          return variant['option' + (index + 1)] === value;
        });
      }) || null;
    }

    function formatVariantMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney && KS.moneyFormat) {
        return Shopify.formatMoney(cents, KS.moneyFormat);
      }
      return formatMoney(cents);
    }

    function updatePrice(variant) {
      if (!priceWrap || !variant) return;
      var priceEl = qs('[data-product-price]', priceWrap);
      var compareEl = qs('[data-product-compare]', priceWrap);
      var saveEl = qs('[data-product-save]', priceWrap);
      var priceRoot = priceWrap.querySelector('.price');

      if (isCallForPrice) {
        if (priceRoot) {
          priceRoot.classList.remove('price--on-sale');
          priceRoot.setAttribute('data-call-for-price', 'true');
        }
        if (priceEl) priceEl.textContent = strings.callForPrice;
        if (compareEl) {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
        if (saveEl) {
          saveEl.hidden = true;
          saveEl.textContent = '';
        }
        if (saleBadge) saleBadge.hidden = true;
        return;
      }

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (priceEl) priceEl.textContent = formatVariantMoney(variant.price);

      if (onSale) {
        if (priceRoot) priceRoot.classList.add('price--on-sale');
        if (!compareEl) {
          compareEl = document.createElement('s');
          compareEl.className = 'price__compare';
          compareEl.setAttribute('data-product-compare', '');
          if (priceEl && priceEl.parentNode) priceEl.parentNode.appendChild(compareEl);
        }
        compareEl.hidden = false;
        compareEl.textContent = formatVariantMoney(variant.compare_at_price);
        if (!saveEl) {
          saveEl = document.createElement('span');
          saveEl.className = 'price__badge';
          saveEl.setAttribute('data-product-save', '');
          if (priceEl && priceEl.parentNode) priceEl.parentNode.appendChild(saveEl);
        }
        var savePercent = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        saveEl.hidden = false;
        saveEl.textContent = savePercent + '% OFF';
        if (saleBadge) saleBadge.hidden = false;
      } else {
        if (priceRoot) priceRoot.classList.remove('price--on-sale');
        if (compareEl) {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
        if (saveEl) {
          saveEl.hidden = true;
          saveEl.textContent = '';
        }
        if (saleBadge) saleBadge.hidden = true;
      }
    }

    function updateAvailability(variant) {
      if (!availability || !variant) return;
      if (isCallForPrice) {
        availability.hidden = true;
        availability.innerHTML = '';
        if (addBtn) addBtn.disabled = true;
        return;
      }
      availability.hidden = false;
      var available = !!variant.available;
      if (available) {
        availability.innerHTML =
          '<span class="main-product__stock main-product__stock--in">' +
          escapeHtml(strings.inStock) +
          '</span>';
      } else {
        availability.innerHTML =
          '<span class="main-product__stock main-product__stock--out">' +
          escapeHtml(strings.soldOut) +
          '</span>';
      }
      if (addBtn) {
        addBtn.disabled = !available;
      }
      if (addLabel) {
        addLabel.textContent = available ? strings.addToCart : strings.soldOut;
      }
    }

    function updateSku(variant) {
      if (!skuRow) return;
      if (variant && variant.sku) {
        skuRow.hidden = false;
        if (skuValue) skuValue.textContent = variant.sku;
      } else {
        skuRow.hidden = true;
        if (skuValue) skuValue.textContent = '';
      }
    }

    function updateMediaForVariant(variant) {
      if (!gallery || !variant) return;
      var mediaId = variant.featured_media && variant.featured_media.id;
      if (mediaId) gallery.showMedia(mediaId);
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      updatePrice(variant);
      updateAvailability(variant);
      updateSku(variant);
      updateMediaForVariant(variant);

      if (history && history.replaceState && variant.url) {
        try {
          history.replaceState({}, '', variant.url);
        } catch (e) {}
      }
    }

    function onOptionChange() {
      var variant = findVariant(getSelectedOptions());
      if (variant) applyVariant(variant);
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', onOptionChange);
    });

    if (form) {
      form.setAttribute('data-product-form-ready', 'true');
    }
  }

  qsa('[data-main-product]').forEach(initProductSection);

  function initCollectionFacets(root) {
    root = root || document;
    var section = qs('[data-main-collection]', root) || root;

    qsa('[data-collection-sort]', section).forEach(function (select) {
      if (select.getAttribute('data-sort-bound') === 'true') return;
      select.setAttribute('data-sort-bound', 'true');
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });

    if (!section._ksFacetsDelegated) {
      section._ksFacetsDelegated = true;
      section.addEventListener('change', function (e) {
        var input = e.target && e.target.closest ? e.target.closest('[data-facet-input]') : null;
        if (!input || !section.contains(input)) return;
        if (input.form) input.form.submit();
      });
    }
    var panel = qs('[data-facets-panel]', section);
    var overlay = qs('[data-facets-overlay]', section);
    var toggle = qs('[data-facets-toggle]', section);
    var closeBtn = qs('[data-facets-close]', section);

    function openFacets() {
      if (!panel) return;
      panel.classList.add('is-open');
      if (overlay) overlay.hidden = false;
      document.body.classList.add('facets-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    function closeFacets() {
      if (!panel) return;
      panel.classList.remove('is-open');
      if (overlay) overlay.hidden = true;
      document.body.classList.remove('facets-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    if (toggle && toggle.getAttribute('data-facets-toggle-bound') !== 'true') {
      toggle.setAttribute('data-facets-toggle-bound', 'true');
      toggle.addEventListener('click', function () {
        if (panel && panel.classList.contains('is-open')) closeFacets();
        else openFacets();
      });
    }

    if (closeBtn && closeBtn.getAttribute('data-facets-close-bound') !== 'true') {
      closeBtn.setAttribute('data-facets-close-bound', 'true');
      closeBtn.addEventListener('click', closeFacets);
    }

    if (overlay && overlay.getAttribute('data-facets-overlay-bound') !== 'true') {
      overlay.setAttribute('data-facets-overlay-bound', 'true');
      overlay.addEventListener('click', closeFacets);
    }
  }

  initCollectionFacets(document);

  window.KS.openCartDrawer = openCartDrawer;
  window.KS.closeDrawers = closeDrawers;

  /* ================================================================ *
   * Phase 4 Step 7 — Quick Order
   *
   * Searches Shopify's predictive-search API by name/model/SKU,
   * resolves variants from /products/<handle>.js, and adds to
   * the cart using the existing addToCartFromForm flow.
   * ================================================================ */
  function initQuickOrder(root) {
    if (!root || root.getAttribute('data-qo-bound') === 'true') return;
    root.setAttribute('data-qo-bound', 'true');

    var strings = KS.strings || {};
    var routes = KS.routes || {};

    function predictiveUrl() {
      var base = routes.predictive_search_url || '/search/suggest';
      return base.indexOf('.json') > -1 ? base : base + '.json';
    }

    function shopRoot() {
      var r = routes.root_url || '/';
      return r.charAt(r.length - 1) === '/' ? r : r + '/';
    }

    function productUrl(handle) {
      if (!isProductHandle(handle)) return shopRoot() + 'products/';
      return shopRoot() + 'products/' + encodeURIComponent(handle);
    }

    /* ---- Per-row controller ---- */
    function initRow(row) {
      if (!row || row.getAttribute('data-qo-row-bound') === 'true') return;
      row.setAttribute('data-qo-row-bound', 'true');

      var input = qs('[data-qo-input]', row);
      var resultsBox = qs('[data-qo-results]', row);
      var productPane = qs('[data-qo-product]', row);
      var mediaEl = qs('[data-qo-media]', row);
      var titleEl = qs('[data-qo-product-title]', row);
      var linkEl = qs('[data-qo-product-link]', row);
      var vendorEl = qs('[data-qo-product-vendor]', row);
      var priceEl = qs('[data-qo-product-price]', row);
      var availEl = qs('[data-qo-product-availability]', row);
      var variantWrap = qs('[data-qo-variant-wrap]', row);
      var variantSelect = qs('[data-qo-variant]', row);
      var qtyInput = qs('[data-qo-qty]', row);
      var decBtn = qs('[data-qo-qty-dec]', row);
      var incBtn = qs('[data-qo-qty-inc]', row);
      var addBtn = qs('[data-qo-add]', row);
      var feedback = qs('[data-qo-feedback]', row);
      var clearBtn = qs('[data-qo-clear]', row);

      var product = null;
      var searchTimer = null;
      var searchSeq = 0;
      var searchAbort = null;

      function showFeedback(msg, type) {
        if (!feedback) return;
        feedback.textContent = msg;
        feedback.className = 'quick-order__feedback' + (type ? ' quick-order__feedback--' + type : '');
        feedback.hidden = false;
      }

      function hideFeedback() {
        if (feedback) { feedback.textContent = ''; feedback.hidden = true; }
      }

      function refreshAddBtn() {
        if (!addBtn) return;
        if (!product) { addBtn.disabled = true; return; }
        var vid = selectedVariantId();
        if (!vid) { addBtn.disabled = true; return; }
        var v = product.variants.find(function (vv) { return vv.id === vid; });
        addBtn.disabled = !(v && v.available && !productIsCallForPrice(product));
      }

      function selectedVariantId() {
        if (!product) return null;
        if (product.variants.length === 1) return product.variants[0].id;
        if (variantSelect) return Number(variantSelect.value) || null;
        return null;
      }

      function resultImageUrl(p) {
        var raw =
          (p.featured_image && p.featured_image.url) ||
          p.image ||
          '';
        if (!isSafeHttpUrl(raw)) return '';
        var sep = raw.indexOf('?') > -1 ? '&' : '?';
        return raw + sep + 'width=80';
      }

      /* Search */
      function doSearch(q) {
        if (!q || q.length < 2) {
          if (searchAbort) {
            searchAbort.abort();
            searchAbort = null;
          }
          resultsBox.innerHTML = '';
          resultsBox.hidden = true;
          return;
        }
        if (q.length > 200) q = q.slice(0, 200);
        var seq = ++searchSeq;
        if (searchAbort) searchAbort.abort();
        searchAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var url =
          predictiveUrl() +
          '?q=' +
          encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';
        fetch(url, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: searchAbort ? searchAbort.signal : undefined
        })
          .then(function (r) {
            if (!r.ok) throw new Error('search_failed');
            return r.json();
          })
          .then(function (data) {
            if (seq !== searchSeq) return;
            var products =
              (data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(products);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            if (seq !== searchSeq) return;
            resultsBox.textContent = '';
            var empty = document.createElement('div');
            empty.className = 'quick-order__no-results';
            empty.textContent =
              strings.qoNotFound ||
              'Product not found. Please check the product name, model or SKU.';
            resultsBox.appendChild(empty);
            resultsBox.hidden = false;
          });
      }

      function renderResults(products) {
        resultsBox.textContent = '';
        if (!products.length) {
          var empty = document.createElement('div');
          empty.className = 'quick-order__no-results';
          empty.textContent =
            strings.qoNotFound ||
            'Product not found. Please check the product name, model or SKU.';
          resultsBox.appendChild(empty);
          resultsBox.hidden = false;
          return;
        }
        products.forEach(function (p) {
          if (!isProductHandle(p.handle)) return;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'quick-order__result';
          btn.setAttribute('data-qo-pick', p.handle);
          btn.setAttribute('role', 'option');

          var imgSrc = resultImageUrl(p);
          if (imgSrc) {
            var img = document.createElement('img');
            img.className = 'quick-order__result-img';
            img.src = imgSrc;
            img.alt = '';
            img.loading = 'lazy';
            btn.appendChild(img);
          }

          var info = document.createElement('span');
          info.className = 'quick-order__result-info';
          var title = document.createElement('strong');
          title.className = 'quick-order__result-title';
          title.textContent = p.title || '';
          info.appendChild(title);
          if (p.vendor) {
            var vendor = document.createElement('span');
            vendor.className = 'quick-order__result-vendor';
            vendor.textContent = p.vendor;
            info.appendChild(vendor);
          }
          var price = document.createElement('span');
          price.className = 'quick-order__result-price';
          if (productIsCallForPrice(p)) {
            price.textContent = callForPriceLabel();
          } else {
            var cents = null;
            var rawPrice = p.price != null ? p.price : p.price_min;
            if (typeof rawPrice === 'number') {
              cents = Math.round(rawPrice);
            } else if (rawPrice != null && rawPrice !== '') {
              var asText = String(rawPrice).replace(/,/g, '').trim();
              if (/^\d+\.\d{1,2}$/.test(asText)) {
                cents = Math.round(parseFloat(asText) * 100);
              } else if (/^\d+$/.test(asText)) {
                cents = parseInt(asText, 10) * 100;
              }
            }
            price.textContent = cents != null && !isNaN(cents) ? formatMoney(cents) : '';
          }
          info.appendChild(price);
          btn.appendChild(info);
          resultsBox.appendChild(btn);
        });
        resultsBox.hidden = false;
      }

      /* Pick a product from search results */
      function pickProduct(handle) {
        resultsBox.innerHTML = '';
        resultsBox.hidden = true;
        if (input) input.value = '';
        hideFeedback();
        if (!isProductHandle(handle)) {
          showFeedback(strings.qoNotFound || 'Product not found.', 'error');
          return;
        }

        fetch(productUrl(handle) + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then(function (r) {
            if (!r.ok) throw new Error('resolve_failed');
            return r.json();
          })
          .then(function (data) {
            if (!data || !isProductHandle(data.handle)) throw new Error('invalid');
            product = data;
            renderProduct();
          })
          .catch(function () {
            showFeedback(strings.qoNotFound || 'Product not found.', 'error');
          });
      }

      function renderProduct() {
        if (!product) return;
        var url = productUrl(product.handle);

        if (linkEl && isSafeHttpUrl(url)) linkEl.href = url;
        if (titleEl) titleEl.textContent = product.title;
        if (vendorEl) {
          vendorEl.textContent = product.vendor || '';
          vendorEl.hidden = !product.vendor;
        }

        if (mediaEl) {
          mediaEl.textContent = '';
          if (product.featured_image && isSafeHttpUrl(product.featured_image)) {
            var a = document.createElement('a');
            a.href = url;
            var img = document.createElement('img');
            img.src = cdnImage(product.featured_image, 200);
            img.alt = product.title || '';
            img.loading = 'lazy';
            a.appendChild(img);
            mediaEl.appendChild(a);
          } else {
            var ph = document.createElement('div');
            ph.className = 'product-card__placeholder';
            ph.textContent = strings.imagePlaceholder || 'Product image';
            mediaEl.appendChild(ph);
          }
        }

        // Price
        if (priceEl) {
          var v = product.variants[0];
          priceEl.textContent = '';
          var reg = document.createElement('span');
          reg.className = 'price__regular';
          if (productIsCallForPrice(product)) {
            reg.textContent = callForPriceLabel();
            priceEl.appendChild(reg);
          } else {
            reg.textContent = formatMoney(v.price);
            priceEl.appendChild(reg);
            if (v.compare_at_price && v.compare_at_price > v.price) {
              priceEl.appendChild(document.createTextNode(' '));
              var cmp = document.createElement('s');
              cmp.className = 'price__compare';
              cmp.textContent = formatMoney(v.compare_at_price);
              priceEl.appendChild(cmp);
            }
          }
        }

        // Availability
        if (availEl) {
          var qoCfp = productIsCallForPrice(product);
          var anyAvailable = qoCfp || product.variants.some(function (vv) { return vv.available; });
          availEl.textContent = '';
          var stock = document.createElement('span');
          stock.className = anyAvailable ? 'quick-order__in-stock' : 'quick-order__out-of-stock';
          stock.textContent = anyAvailable
            ? (strings.inStock || 'In Stock')
            : (strings.soldOut || 'Sold out');
          availEl.appendChild(stock);
        }

        // Variants
        if (product.variants.length > 1 && variantWrap && variantSelect) {
          variantSelect.innerHTML = '';
          product.variants.forEach(function (vv) {
            var opt = document.createElement('option');
            var vvOk = productIsCallForPrice(product) || vv.available;
            opt.value = vv.id;
            opt.textContent = vv.title + (vvOk ? '' : ' — ' + (strings.soldOut || 'Sold out'));
            opt.disabled = !vvOk;
            variantSelect.appendChild(opt);
          });
          // Auto-select first available
          var firstAvail = product.variants.find(function (vv) {
            return productIsCallForPrice(product) || vv.available;
          });
          if (firstAvail) variantSelect.value = firstAvail.id;
          variantWrap.hidden = false;
        } else {
          if (variantWrap) variantWrap.hidden = true;
        }

        // Reset qty
        if (qtyInput) qtyInput.value = '1';
        if (productPane) productPane.hidden = false;
        if (clearBtn) clearBtn.hidden = false;
        refreshAddBtn();
      }

      function updatePriceForVariant() {
        if (!product || !priceEl) return;
        var vid = selectedVariantId();
        var v = product.variants.find(function (vv) { return vv.id === vid; });
        if (!v) return;
        priceEl.textContent = '';
        var reg = document.createElement('span');
        reg.className = 'price__regular';
        if (productIsCallForPrice(product)) {
          reg.textContent = callForPriceLabel();
          priceEl.appendChild(reg);
        } else {
          reg.textContent = formatMoney(v.price);
          priceEl.appendChild(reg);
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceEl.appendChild(document.createTextNode(' '));
            var cmp = document.createElement('s');
            cmp.className = 'price__compare';
            cmp.textContent = formatMoney(v.compare_at_price);
            priceEl.appendChild(cmp);
          }
        }

        if (availEl) {
          var ok = productIsCallForPrice(product) || v.available;
          availEl.textContent = '';
          var stock = document.createElement('span');
          stock.className = ok ? 'quick-order__in-stock' : 'quick-order__out-of-stock';
          stock.textContent = ok
            ? (strings.inStock || 'In Stock')
            : (strings.soldOut || 'Sold out');
          availEl.appendChild(stock);
        }
        refreshAddBtn();
      }

      function clearRow() {
        product = null;
        if (input) input.value = '';
        if (productPane) productPane.hidden = true;
        if (clearBtn) clearBtn.hidden = true;
        if (resultsBox) { resultsBox.innerHTML = ''; resultsBox.hidden = true; }
        if (variantWrap) variantWrap.hidden = true;
        if (variantSelect) variantSelect.innerHTML = '';
        if (qtyInput) qtyInput.value = '1';
        hideFeedback();
        refreshAddBtn();
      }

      /* Add to cart — builds a tiny form and delegates to the existing addToCartFromForm */
      function addToCart() {
        if (!product) return;
        var vid = selectedVariantId();
        if (!vid) return;
        var v = product.variants.find(function (vv) { return vv.id === vid; });
        if (!v || !v.available || productIsCallForPrice(product)) {
          showFeedback(
            productIsCallForPrice(product)
              ? callForPriceLabel()
              : strings.qoUnavailable || 'This variant is currently unavailable.',
            'error'
          );
          return;
        }
        var qty = normalizeAddQuantity(qtyInput && qtyInput.value);

        addBtn.disabled = true;
        hideFeedback();

        var form = document.createElement('form');
        form.method = 'POST';
        form.action = cartRoute('cart_add_url', '/cart/add');
        var idInput = document.createElement('input');
        idInput.type = 'hidden'; idInput.name = 'id'; idInput.value = vid;
        form.appendChild(idInput);
        var qInput = document.createElement('input');
        qInput.type = 'hidden'; qInput.name = 'quantity'; qInput.value = qty;
        form.appendChild(qInput);
        document.body.appendChild(form);

        addToCartFromForm(form)
          .then(function () {
            showFeedback(
              (strings.qoAdded || 'Added to cart!')
                .replace('{{ title }}', product.title)
                .replace('{{ qty }}', qty),
              'success'
            );
          })
          .catch(function () {
            showFeedback(strings.cartError || 'Something went wrong. Please try again.', 'error');
          })
          .finally(function () {
            form.remove();
            refreshAddBtn();
          });
      }

      /* Event wiring */
      if (input) {
        input.addEventListener('input', function () {
          clearTimeout(searchTimer);
          searchTimer = setTimeout(function () { doSearch(input.value.trim()); }, 300);
        });
        input.addEventListener('focus', function () {
          if (input.value.trim().length >= 2 && resultsBox.children.length > 0) {
            resultsBox.hidden = false;
          }
        });
      }

      if (resultsBox) {
        resultsBox.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-qo-pick]');
          if (btn) pickProduct(btn.getAttribute('data-qo-pick'));
        });
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', updatePriceForVariant);
      }

      if (decBtn && qtyInput) {
        decBtn.addEventListener('click', function () {
          qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1 || 1);
        });
      }
      if (incBtn && qtyInput) {
        incBtn.addEventListener('click', function () {
          qtyInput.value = normalizeAddQuantity((parseInt(qtyInput.value, 10) || 1) + 1);
        });
      }
      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          qtyInput.value = String(normalizeAddQuantity(qtyInput.value));
        });
      }

      if (addBtn) addBtn.addEventListener('click', addToCart);
      if (clearBtn) clearBtn.addEventListener('click', clearRow);
    }

    /* One delegated outside-click handler for all Quick Order rows */
    if (!root._ksQoOutsideBound) {
      root._ksQoOutsideBound = true;
      document.addEventListener('click', function (e) {
        qsa('[data-qo-row]', root).forEach(function (row) {
          var box = qs('[data-qo-results]', row);
          if (box && !row.contains(e.target)) box.hidden = true;
        });
      });
    }

    /* ---- Add-row button ---- */
    var addRowBtn = qs('[data-qo-add-row]', root);
    var rowsContainer = qs('[data-qo-rows]', root);
    var rowIndex = 1;

    if (addRowBtn && rowsContainer) {
      addRowBtn.addEventListener('click', function () {
        var template = qs('[data-qo-row]', rowsContainer);
        if (!template) return;
        var clone = template.cloneNode(true);
        clone.removeAttribute('data-qo-row-bound');
        // Give unique IDs to form elements
        qsa('[id]', clone).forEach(function (el) {
          el.id = el.id.replace(/-\d+$/, '-' + rowIndex);
        });
        qsa('label[for]', clone).forEach(function (el) {
          el.setAttribute('for', el.getAttribute('for').replace(/-\d+$/, '-' + rowIndex));
        });
        // Reset state
        var inp = qs('[data-qo-input]', clone);
        if (inp) inp.value = '';
        var pp = qs('[data-qo-product]', clone);
        if (pp) pp.hidden = true;
        var cb = qs('[data-qo-clear]', clone);
        if (cb) cb.hidden = true;
        var fb = qs('[data-qo-feedback]', clone);
        if (fb) { fb.hidden = true; fb.textContent = ''; }
        var res = qs('[data-qo-results]', clone);
        if (res) { res.innerHTML = ''; res.hidden = true; }
        var ab = qs('[data-qo-add]', clone);
        if (ab) ab.disabled = true;

        // Close control for additional rows only — sits in the reserved top strip
        clone.classList.add('quick-order__row--removable');
        var closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'quick-order__row-close';
        closeBtn.setAttribute('aria-label', 'Remove product row');
        closeBtn.innerHTML = '&times;';
        closeBtn.addEventListener('click', function () { clone.remove(); });
        clone.appendChild(closeBtn);

        rowsContainer.appendChild(clone);
        initRow(clone);
        rowIndex++;
        if (inp) inp.focus();
      });
    }

    /* Init existing rows */
    qsa('[data-qo-row]', root).forEach(initRow);
  }

  qsa('[data-quick-order]').forEach(initQuickOrder);

  /* ---------------------------------------------------------------- *
   * Lightweight catalog search index (scalable via products.json pages)
   * Compact fields only — title/sku/vendor/type/price/thumb — cached in
   * sessionStorage so common/model queries paint instantly without waiting
   * on /search/suggest.json. Shopify predictive still validates in background.
   * ---------------------------------------------------------------- */
  var SEARCH_INDEX_KEY = 'ks_search_index_v2';
  var SEARCH_INDEX_META = 'ks_search_index_meta_v2';
  var searchIndexState = {
    items: null,
    loading: null,
    ready: false
  };

  function normalizeSearchText(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function compactSearchKey(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  function loadCachedSearchIndex() {
    try {
      var raw = sessionStorage.getItem(SEARCH_INDEX_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.items)) return null;
      return parsed.items;
    } catch (e) {
      return null;
    }
  }

  function isSearchIndexFresh() {
    try {
      var raw = sessionStorage.getItem(SEARCH_INDEX_META);
      if (!raw) {
        raw = sessionStorage.getItem(SEARCH_INDEX_KEY);
        if (!raw) return false;
        var parsedKey = JSON.parse(raw);
        return !!(parsedKey && parsedKey.ts && Date.now() - parsedKey.ts < 30 * 60 * 1000);
      }
      var meta = JSON.parse(raw);
      return !!(meta && meta.ts && Date.now() - meta.ts < 30 * 60 * 1000);
    } catch (e) {
      return false;
    }
  }

  function saveCachedSearchIndex(items) {
    try {
      sessionStorage.setItem(
        SEARCH_INDEX_KEY,
        JSON.stringify({ v: 1, ts: Date.now(), items: items })
      );
      sessionStorage.setItem(
        SEARCH_INDEX_META,
        JSON.stringify({ v: 1, ts: Date.now(), count: items.length })
      );
    } catch (e) {
      /* Quota exceeded — keep in-memory only. */
    }
  }

  function mapProductJsonToIndexItem(p) {
    if (!p || !p.handle) return null;
    var skus = [];
    (p.variants || []).forEach(function (v) {
      if (v && v.sku) skus.push(String(v.sku));
    });
    var priceRaw = null;
    if (p.variants && p.variants[0] && p.variants[0].price != null) {
      priceRaw = p.variants[0].price;
    } else if (p.price != null) {
      priceRaw = p.price;
    }
    var cents = null;
    if (typeof priceRaw === 'number') {
      /* products.json prices are major units (e.g. 10600.00) */
      cents = Math.round(priceRaw * 100);
    } else if (priceRaw != null && priceRaw !== '') {
      var asText = String(priceRaw).replace(/,/g, '').trim();
      if (/^\d+(\.\d+)?$/.test(asText)) cents = Math.round(parseFloat(asText) * 100);
    }
    var img = '';
    if (p.images && p.images[0] && p.images[0].src) img = p.images[0].src;
    else if (p.featured_image) img = typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src || '';
    return {
      handle: p.handle,
      title: p.title || '',
      vendor: p.vendor || '',
      type: p.product_type || p.type || '',
      skus: skus,
      price: cents,
      callForPrice: productIsCallForPrice(p),
      image: img,
      url: '/products/' + encodeURIComponent(p.handle),
      _n: normalizeSearchText(
        [p.title, p.vendor, p.product_type || p.type].concat(skus).join(' ')
      ),
      _c: compactSearchKey([p.title].concat(skus).join(''))
    };
  }

  function ensureSearchIndex() {
    if (searchIndexState.items) {
      searchIndexState.ready = true;
      return Promise.resolve(searchIndexState.items);
    }
    var cached = loadCachedSearchIndex();
    if (cached && cached.length) {
      searchIndexState.items = cached;
      searchIndexState.ready = true;
      /* Refresh in background only when cache is stale (30 min). */
      if (!searchIndexState.loading && !isSearchIndexFresh()) {
        searchIndexState.loading = fetchSearchIndexPages().finally(function () {
          searchIndexState.loading = null;
        });
      }
      return Promise.resolve(cached);
    }
    if (searchIndexState.loading) return searchIndexState.loading;
    searchIndexState.loading = fetchSearchIndexPages().finally(function () {
      searchIndexState.loading = null;
    });
    return searchIndexState.loading;
  }

  function fetchSearchIndexPages() {
    var root = shopRoot();
    var page = 1;
    var all = [];
    /* Cap crawl: predictive search covers the long tail; avoid 40×250 JSON storms. */
    var maxPages = 6;

    function next() {
      if (page > maxPages) {
        searchIndexState.items = all;
        searchIndexState.ready = true;
        saveCachedSearchIndex(all);
        return Promise.resolve(all);
      }
      return fetch(
        root +
          'collections/all/products.json?limit=250&page=' +
          page,
        { credentials: 'same-origin', headers: { Accept: 'application/json' } }
      )
        .then(function (r) {
          if (!r.ok) throw new Error('index_fetch_failed');
          return r.json();
        })
        .then(function (data) {
          var batch = (data && data.products) || [];
          batch.forEach(function (p) {
            var item = mapProductJsonToIndexItem(p);
            if (item) all.push(item);
          });
          searchIndexState.items = all.slice();
          searchIndexState.ready = true;
          if (batch.length < 250) {
            saveCachedSearchIndex(all);
            return all;
          }
          page += 1;
          /* Yield between pages so typing/scroll stay responsive. */
          return new Promise(function (resolve) {
            var cont = function () {
              resolve(next());
            };
            if (typeof window.requestIdleCallback === 'function') {
              window.requestIdleCallback(cont, { timeout: 800 });
            } else {
              setTimeout(cont, 60);
            }
          });
        });
    }

    return next().catch(function () {
      if (all.length) {
        searchIndexState.items = all;
        searchIndexState.ready = true;
        saveCachedSearchIndex(all);
      }
      return searchIndexState.items || [];
    });
  }

  function scoreIndexItem(item, qNorm, qCompact) {
    if (!item) return 0;
    var score = 0;
    var i;
    for (i = 0; i < (item.skus || []).length; i++) {
      var skuN = normalizeSearchText(item.skus[i]);
      var skuC = compactSearchKey(item.skus[i]);
      if (skuN === qNorm || skuC === qCompact) score = Math.max(score, 100);
      else if (skuC.indexOf(qCompact) === 0 || skuN.indexOf(qNorm) === 0) score = Math.max(score, 90);
      else if (skuC.indexOf(qCompact) > -1 || skuN.indexOf(qNorm) > -1) score = Math.max(score, 80);
    }
    var titleN = normalizeSearchText(item.title);
    var titleC = compactSearchKey(item.title);
    if (titleN === qNorm) score = Math.max(score, 95);
    else if (titleC.indexOf(qCompact) > -1) score = Math.max(score, 70);
    else if (titleN.indexOf(qNorm) > -1) score = Math.max(score, 65);
    if (item._n && item._n.indexOf(qNorm) > -1) score = Math.max(score, 50);
    if (qCompact.length >= 3 && item._c && item._c.indexOf(qCompact) > -1) score = Math.max(score, 55);
    return score;
  }

  function searchLocalIndex(q, limit) {
    var items = searchIndexState.items;
    if (!items || !items.length) return [];
    var qNorm = normalizeSearchText(q);
    var qCompact = compactSearchKey(q);
    if (!qNorm && !qCompact) return [];
    var scored = [];
    var i;
    for (i = 0; i < items.length; i++) {
      var s = scoreIndexItem(items[i], qNorm, qCompact);
      if (s > 0) scored.push({ s: s, item: items[i] });
    }
    scored.sort(function (a, b) {
      return b.s - a.s;
    });
    return scored.slice(0, limit || 6).map(function (x) {
      return x.item;
    });
  }

  function indexItemToPredictiveShape(item) {
    return {
      handle: item.handle,
      title: item.title,
      url: item.url,
      vendor: item.vendor,
      type: item.type,
      price: item.price,
      callForPrice: !!item.callForPrice,
      tags: item.callForPrice ? CALL_FOR_PRICE_TAG : '',
      image: item.image ? { url: item.image } : null,
      featured_image: item.image || null
    };
  }

  /* ---------------------------------------------------------------- *
   * Header / drawer predictive search (local index + Shopify validate)
   * ---------------------------------------------------------------- */
  function initPredictiveSearch(form) {
    if (!form || form.getAttribute('data-predictive-bound') === 'true') return;
    form.setAttribute('data-predictive-bound', 'true');

    var input = qs('[data-predictive-search-input]', form);
    var results = qs('[data-predictive-search-results]', form);
    if (!input || !results) return;

    var timer = null;
    var seq = 0;
    var abortCtrl = null;
    var routes = KS.routes || {};
    var lastRenderedQ = '';
    var lastRenderedKey = '';
    var queryCache = Object.create(null);
    var DEBOUNCE_MS = 220;
    var MIN_QUERY = 2;

    function predictiveEndpoint() {
      var base = routes.predictive_search_url || '/search/suggest';
      return base.indexOf('.json') > -1 ? base : base + '.json';
    }

    function hideResults() {
      results.hidden = true;
      results.textContent = '';
      input.setAttribute('aria-expanded', 'false');
      lastRenderedKey = '';
    }

    function showResults() {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function showLoading(q) {
      var loading = document.createElement('div');
      loading.className = 'predictive-search__empty';
      loading.textContent = 'Searching…';
      if (lastRenderedQ !== q || !results.children.length) {
        results.textContent = '';
        results.appendChild(loading);
        showResults();
      }
    }

    function productHref(p) {
      if (p.url && isSafeHttpUrl(p.url)) return p.url;
      if (p.handle && isProductHandle(p.handle)) return productUrlFor(p.handle);
      return routes.search_url || '/search';
    }

    function productImage(p) {
      var raw =
        (p.image && (p.image.url || p.image.src || p.image)) ||
        (p.featured_image && (p.featured_image.url || p.featured_image.src || p.featured_image)) ||
        '';
      if (!raw) return '';
      var url = String(raw).trim();
      if (url.indexOf('//') === 0) url = 'https:' + url;
      if (!isSafeHttpUrl(url)) return '';

      /* Drop prior resize/format params so we always request a small CDN thumb. */
      url = url.replace(/([?&])(width|height|crop|format)=[^&]*/gi, function (match, sep) {
        return sep === '?' ? '?' : '';
      });
      url = url.replace(/\?&/g, '?').replace(/[?&]$/g, '');

      var sep = url.indexOf('?') > -1 ? '&' : '?';
      /* One 96px WebP request for 48 CSS px thumbs — no srcset double-fetch. */
      return url + sep + 'width=96&format=webp';
    }

    function productsKey(products) {
      return (products || [])
        .map(function (p) {
          return (p && (p.handle || p.url || p.title)) || '';
        })
        .join('|');
    }

    function renderIfChanged(products, q) {
      var key = productsKey(products);
      if (q === lastRenderedQ && key === lastRenderedKey && results.children.length) {
        queryCache[q.toLowerCase()] = products;
        showResults();
        return false;
      }
      render(products, q);
      return true;
    }

    function render(products, q) {
      results.textContent = '';
      lastRenderedQ = q;
      lastRenderedKey = productsKey(products);
      queryCache[q.toLowerCase()] = products;
      if (!products.length) {
        var empty = document.createElement('div');
        empty.className = 'predictive-search__empty';
        empty.textContent = (KS.strings && KS.strings.searchNoResults) || 'No products found.';
        results.appendChild(empty);
        showResults();
        return;
      }

      products.forEach(function (p, idx) {
        if (!p || (!p.handle && !p.url)) return;
        var a = document.createElement('a');
        a.className = 'predictive-search__item';
        a.href = productHref(p);
        a.setAttribute('role', 'option');

        var src = productImage(p);
        if (src) {
          var img = document.createElement('img');
          img.className = 'predictive-search__img';
          img.alt = '';
          img.width = 48;
          img.height = 48;
          img.decoding = 'async';
          /* Visible dropdown thumbs must NOT use lazy — detached+lazy previously never fetched. */
          img.loading = 'eager';
          if (idx < 4) img.setAttribute('fetchpriority', 'high');
          /* Append + set src immediately so download starts with the result row. */
          a.appendChild(img);
          img.src = src;
        } else {
          var ph = document.createElement('span');
          ph.className = 'predictive-search__img-ph';
          ph.setAttribute('aria-hidden', 'true');
          a.appendChild(ph);
        }

        var title = document.createElement('span');
        title.className = 'predictive-search__title';
        title.textContent = p.title || p.handle || '';
        a.appendChild(title);

        var price = document.createElement('span');
        price.className = 'predictive-search__price';
        if (productIsCallForPrice(p) || p.callForPrice) {
          price.textContent = callForPriceLabel();
        } else {
          var cents = null;
          if (p._localCents != null && !isNaN(p._localCents)) {
            cents = p._localCents;
          } else {
            var rawPrice = p.price != null ? p.price : p.price_min;
            if (typeof rawPrice === 'number') {
              cents = Math.round(rawPrice);
            } else if (rawPrice != null && rawPrice !== '') {
              var asText = String(rawPrice).replace(/,/g, '').trim();
              if (/^\d+\.\d{1,2}$/.test(asText)) {
                cents = Math.round(parseFloat(asText) * 100);
              } else if (/^\d+$/.test(asText)) {
                cents = parseInt(asText, 10) * 100;
              }
            }
          }
          if (cents != null && !isNaN(cents)) {
            price.textContent = formatMoney(cents);
          } else {
            price.textContent = '';
          }
        }
        a.appendChild(price);
        results.appendChild(a);
      });

      var viewAll = document.createElement('a');
      viewAll.className = 'predictive-search__view-all';
      viewAll.href = (routes.search_url || '/search') + '?q=' + encodeURIComponent(q);
      viewAll.textContent = 'View all results';
      results.appendChild(viewAll);
      showResults();
    }

    function localSnapshotFor(q) {
      return searchLocalIndex(q, 6).map(function (item) {
        var shaped = indexItemToPredictiveShape(item);
        shaped._localCents = item.price;
        shaped.callForPrice = !!item.callForPrice;
        return shaped;
      });
    }

    function mergeRemote(localProducts, remoteProducts) {
      var seen = {};
      var out = [];
      function push(p) {
        if (!p) return;
        var key = p.handle || p.url || p.title;
        if (!key || seen[key]) return;
        seen[key] = true;
        out.push(p);
      }
      (localProducts || []).forEach(push);
      (remoteProducts || []).forEach(push);
      return out.slice(0, 6);
    }

    function runRemoteSearch(q, mySeq, localSnapshot) {
      if (abortCtrl) abortCtrl.abort();
      abortCtrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var url =
        predictiveEndpoint() +
        '?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';

      fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: abortCtrl ? abortCtrl.signal : undefined
      })
        .then(function (r) {
          if (!r.ok) throw new Error('predictive_failed');
          return r.json();
        })
        .then(function (data) {
          if (mySeq !== seq) return;
          var remote =
            (data.resources && data.resources.results && data.resources.results.products) || [];
          var merged = mergeRemote(localSnapshot, remote);
          if (merged.length) renderIfChanged(merged, q);
          else if (!localSnapshot || !localSnapshot.length) render([], q);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (mySeq !== seq) return;
          if (!localSnapshot || !localSnapshot.length) hideResults();
        });
    }

    function handleQuery(q) {
      if (!q || q.length < MIN_QUERY) {
        if (abortCtrl) abortCtrl.abort();
        hideResults();
        return;
      }
      if (q.length > 200) q = q.slice(0, 200);

      var cacheKey = q.toLowerCase();
      if (queryCache[cacheKey]) {
        renderIfChanged(queryCache[cacheKey], q);
        var mySeqCached = ++seq;
        runRemoteSearch(q, mySeqCached, queryCache[cacheKey]);
        return;
      }

      var localSnapshot = localSnapshotFor(q);
      if (localSnapshot.length) {
        renderIfChanged(localSnapshot, q);
      } else {
        showLoading(q);
      }

      var mySeq = ++seq;
      runRemoteSearch(q, mySeq, localSnapshot);
    }

    /* Warm local index well after focus so first predictive request wins the network. */
    input.addEventListener('focus', function () {
      var warm = function () {
        ensureSearchIndex();
      };
      setTimeout(function () {
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(warm, { timeout: 4000 });
        } else {
          warm();
        }
      }, 1200);
      if (input.value.trim().length >= MIN_QUERY && results.children.length) showResults();
    }, { passive: true });

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (!q || q.length < MIN_QUERY) {
        if (abortCtrl) abortCtrl.abort();
        hideResults();
        return;
      }
      showLoading(q);
      timer = setTimeout(function () {
        handleQuery(input.value.trim());
      }, DEBOUNCE_MS);
    });

    if (!document.documentElement._ksPredictiveOutsideBound) {
      document.documentElement._ksPredictiveOutsideBound = true;
      document.addEventListener('click', function (e) {
        qsa('[data-predictive-search]').forEach(function (f) {
          if (!f.contains(e.target)) {
            var box = qs('[data-predictive-search-results]', f);
            var inp = qs('[data-predictive-search-input]', f);
            if (box) {
              box.hidden = true;
              box.textContent = '';
            }
            if (inp) inp.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hideResults();
    });
  }

  qsa('[data-predictive-search]').forEach(initPredictiveSearch);

  /* Pause trust ticker CSS animation when off-screen (saves mobile compositor work). */
  (function initTrustTickerPerf() {
    var tracks = qsa('.trust-ticker__track');
    if (!tracks.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
        });
      },
      { rootMargin: '40px 0px', threshold: 0 }
    );
    tracks.forEach(function (el) {
      io.observe(el);
    });
  })();
})();